webpackJsonp([112359326995148],{

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var memoize = _interopDefault(__webpack_require__(305));
	
	var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class)|(on[A-Z].*)|((data|aria|x)-.*))$/i;
	var index = memoize(reactPropsRegex.test.bind(reactPropsRegex));
	
	module.exports = index;


/***/ }),

/***/ 305:
/***/ (function(module, exports) {

	'use strict';
	
	function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) cache[arg] = fn(arg);
	    return cache[arg];
	  };
	}
	
	module.exports = memoize;


/***/ }),

/***/ 306:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var DEFAULT_OVERSHOOT_STRENGTH = 1.525;
	var reversed = function (easing) { return function (p) { return 1 - easing(1 - p); }; };
	var mirrored = function (easing) { return function (p) {
	    return p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
	}; };
	var createReversedEasing = reversed;
	var createMirroredEasing = mirrored;
	var createExpoIn = function (power) { return function (p) { return Math.pow(p, power); }; };
	var createBackIn = function (power) { return function (p) {
	    return p * p * ((power + 1) * p - power);
	}; };
	var createAnticipateEasing = function (power) {
	    var backEasing = createBackIn(power);
	    return function (p) {
	        return (p *= 2) < 1 ? 0.5 * backEasing(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
	    };
	};
	var linear = function (p) { return p; };
	var easeIn = createExpoIn(2);
	var easeOut = reversed(easeIn);
	var easeInOut = mirrored(easeIn);
	var circIn = function (p) { return 1 - Math.sin(Math.acos(p)); };
	var circOut = reversed(circIn);
	var circInOut = mirrored(circOut);
	var backIn = createBackIn(DEFAULT_OVERSHOOT_STRENGTH);
	var backOut = reversed(backIn);
	var backInOut = mirrored(backIn);
	var anticipate = createAnticipateEasing(DEFAULT_OVERSHOOT_STRENGTH);
	var NEWTON_ITERATIONS = 8;
	var NEWTON_MIN_SLOPE = 0.001;
	var SUBDIVISION_PRECISION = 0.0000001;
	var SUBDIVISION_MAX_ITERATIONS = 10;
	var K_SPLINE_TABLE_SIZE = 11;
	var K_SAMPLE_STEP_SIZE = 1.0 / (K_SPLINE_TABLE_SIZE - 1.0);
	var FLOAT_32_SUPPORTED = typeof Float32Array !== 'undefined';
	var a = function (a1, a2) { return 1.0 - 3.0 * a2 + 3.0 * a1; };
	var b = function (a1, a2) { return 3.0 * a2 - 6.0 * a1; };
	var c = function (a1) { return 3.0 * a1; };
	var getSlope = function (t, a1, a2) {
	    return 3.0 * a(a1, a2) * t * t + 2.0 * b(a1, a2) * t + c(a1);
	};
	var calcBezier = function (t, a1, a2) {
	    return ((a(a1, a2) * t + b(a1, a2)) * t + c(a1)) * t;
	};
	function cubicBezier(mX1, mY1, mX2, mY2) {
	    var sampleValues = FLOAT_32_SUPPORTED
	        ? new Float32Array(K_SPLINE_TABLE_SIZE)
	        : new Array(K_SPLINE_TABLE_SIZE);
	    var binarySubdivide = function (aX, aA, aB) {
	        var i = 0;
	        var currentX;
	        var currentT;
	        do {
	            currentT = aA + (aB - aA) / 2.0;
	            currentX = calcBezier(currentT, mX1, mX2) - aX;
	            if (currentX > 0.0) {
	                aB = currentT;
	            }
	            else {
	                aA = currentT;
	            }
	        } while (Math.abs(currentX) > SUBDIVISION_PRECISION &&
	            ++i < SUBDIVISION_MAX_ITERATIONS);
	        return currentT;
	    };
	    var newtonRaphsonIterate = function (aX, aGuessT) {
	        var i = 0;
	        var currentSlope = 0;
	        var currentX;
	        for (; i < NEWTON_ITERATIONS; ++i) {
	            currentSlope = getSlope(aGuessT, mX1, mX2);
	            if (currentSlope === 0.0) {
	                return aGuessT;
	            }
	            currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	            aGuessT -= currentX / currentSlope;
	        }
	        return aGuessT;
	    };
	    var calcSampleValues = function () {
	        for (var i = 0; i < K_SPLINE_TABLE_SIZE; ++i) {
	            sampleValues[i] = calcBezier(i * K_SAMPLE_STEP_SIZE, mX1, mX2);
	        }
	    };
	    var getTForX = function (aX) {
	        var intervalStart = 0.0;
	        var currentSample = 1;
	        var lastSample = K_SPLINE_TABLE_SIZE - 1;
	        var dist = 0.0;
	        var guessForT = 0.0;
	        var initialSlope = 0.0;
	        for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
	            intervalStart += K_SAMPLE_STEP_SIZE;
	        }
	        --currentSample;
	        dist =
	            (aX - sampleValues[currentSample]) /
	                (sampleValues[currentSample + 1] - sampleValues[currentSample]);
	        guessForT = intervalStart + dist * K_SAMPLE_STEP_SIZE;
	        initialSlope = getSlope(guessForT, mX1, mX2);
	        if (initialSlope >= NEWTON_MIN_SLOPE) {
	            return newtonRaphsonIterate(aX, guessForT);
	        }
	        else if (initialSlope === 0.0) {
	            return guessForT;
	        }
	        else {
	            return binarySubdivide(aX, intervalStart, intervalStart + K_SAMPLE_STEP_SIZE);
	        }
	    };
	    calcSampleValues();
	    var resolver = function (aX) {
	        var returnValue;
	        if (mX1 === mY1 && mX2 === mY2) {
	            returnValue = aX;
	        }
	        else if (aX === 0) {
	            returnValue = 0;
	        }
	        else if (aX === 1) {
	            returnValue = 1;
	        }
	        else {
	            returnValue = calcBezier(getTForX(aX), mY1, mY2);
	        }
	        return returnValue;
	    };
	    return resolver;
	}
	
	exports.reversed = reversed;
	exports.mirrored = mirrored;
	exports.createReversedEasing = createReversedEasing;
	exports.createMirroredEasing = createMirroredEasing;
	exports.createExpoIn = createExpoIn;
	exports.createBackIn = createBackIn;
	exports.createAnticipateEasing = createAnticipateEasing;
	exports.linear = linear;
	exports.easeIn = easeIn;
	exports.easeOut = easeOut;
	exports.easeInOut = easeInOut;
	exports.circIn = circIn;
	exports.circOut = circOut;
	exports.circInOut = circInOut;
	exports.backIn = backIn;
	exports.backOut = backOut;
	exports.backInOut = backInOut;
	exports.anticipate = anticipate;
	exports.cubicBezier = cubicBezier;


/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 80:
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function createRenderStep(startRenderLoop) {
	    var functionsToRun = [];
	    var functionsToRunNextFrame = [];
	    var numThisFrame = 0;
	    var isProcessing = false;
	    var i = 0;
	    return {
	        cancel: function (callback) {
	            var indexOfCallback = functionsToRunNextFrame.indexOf(callback);
	            if (indexOfCallback !== -1) {
	                functionsToRunNextFrame.splice(indexOfCallback, 1);
	            }
	        },
	        process: function () {
	            isProcessing = true;
	            _a = [functionsToRunNextFrame, functionsToRun], functionsToRun = _a[0], functionsToRunNextFrame = _a[1];
	            functionsToRunNextFrame.length = 0;
	            numThisFrame = functionsToRun.length;
	            for (i = 0; i < numThisFrame; i++) {
	                functionsToRun[i]();
	            }
	            isProcessing = false;
	            var _a;
	        },
	        schedule: function (callback, immediate) {
	            if (immediate === void 0) { immediate = false; }
	            startRenderLoop();
	            var addToCurrentBuffer = immediate && isProcessing;
	            var buffer = addToCurrentBuffer ? functionsToRun : functionsToRunNextFrame;
	            if (buffer.indexOf(callback) === -1) {
	                buffer.push(callback);
	                if (addToCurrentBuffer) {
	                    numThisFrame = functionsToRun.length;
	                }
	            }
	        },
	    };
	}
	exports.default = createRenderStep;
	//# sourceMappingURL=create-render-step.js.map

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var on_next_frame_1 = __webpack_require__(81);
	var create_render_step_1 = __webpack_require__(80);
	var HAS_PERFORMANCE_NOW = typeof performance !== 'undefined' && performance.now !== undefined;
	exports.currentTime = HAS_PERFORMANCE_NOW ? function () { return performance.now(); } : function () { return Date.now(); };
	var willRenderNextFrame = false;
	var MAX_ELAPSED = 40;
	var defaultElapsed = 16.7;
	var useDefaultElapsed = true;
	var currentFramestamp = 0;
	var elapsed = 0;
	function startRenderLoop() {
	    if (willRenderNextFrame)
	        return;
	    willRenderNextFrame = true;
	    useDefaultElapsed = true;
	    on_next_frame_1.default(processFrame);
	}
	var frameStart = create_render_step_1.default(startRenderLoop);
	var frameUpdate = create_render_step_1.default(startRenderLoop);
	var frameRender = create_render_step_1.default(startRenderLoop);
	var frameEnd = create_render_step_1.default(startRenderLoop);
	function processFrame(framestamp) {
	    willRenderNextFrame = false;
	    elapsed = useDefaultElapsed
	        ? defaultElapsed
	        : Math.max(Math.min(framestamp - currentFramestamp, MAX_ELAPSED), 1);
	    if (!useDefaultElapsed)
	        defaultElapsed = elapsed;
	    currentFramestamp = framestamp;
	    frameStart.process();
	    frameUpdate.process();
	    frameRender.process();
	    frameEnd.process();
	    if (willRenderNextFrame)
	        useDefaultElapsed = false;
	}
	exports.onFrameStart = frameStart.schedule;
	exports.onFrameUpdate = frameUpdate.schedule;
	exports.onFrameRender = frameRender.schedule;
	exports.onFrameEnd = frameEnd.schedule;
	exports.cancelOnFrameStart = frameStart.cancel;
	exports.cancelOnFrameUpdate = frameUpdate.cancel;
	exports.cancelOnFrameRender = frameRender.cancel;
	exports.cancelOnFrameEnd = frameEnd.cancel;
	exports.timeSinceLastFrame = function () { return elapsed; };
	exports.currentFrameTime = function () { return currentFramestamp; };
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 81:
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var hasRAF = typeof window !== 'undefined' && window.requestAnimationFrame !== undefined;
	var prevTime = 0;
	var onNextFrame = hasRAF
	    ? function (callback) { return window.requestAnimationFrame(callback); }
	    : function (callback) {
	        var currentTime = Date.now();
	        var timeToCall = Math.max(0, 16.7 - (currentTime - prevTime));
	        prevTime = currentTime + timeToCall;
	        setTimeout(function () { return callback(prevTime); }, timeToCall);
	    };
	exports.default = onNextFrame;
	//# sourceMappingURL=on-next-frame.js.map

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var HEY_LISTEN = 'Hey, listen! ';
	exports.warning = function () { };
	exports.invariant = function () { };
	if (false) {
	    exports.warning = function (check, message) {
	        if (!check && typeof console !== 'undefined') {
	            console.warn(HEY_LISTEN + message);
	        }
	    };
	    exports.invariant = function (check, message) {
	        if (!check) {
	            throw new Error(HEY_LISTEN.toUpperCase() + message);
	        }
	    };
	}


/***/ }),

/***/ 613:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var popmotion = __webpack_require__(9);
	var easing = __webpack_require__(306);
	var styleValueTypes = __webpack_require__(7);
	var poseFactory = _interopDefault(__webpack_require__(614));
	var heyListen = __webpack_require__(169);
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	
	var __assign = function() {
	    __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	function __rest(s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
	            t[p[i]] = s[p[i]];
	    return t;
	}
	
	var BoundingBoxDimension;
	(function (BoundingBoxDimension) {
	    BoundingBoxDimension["width"] = "width";
	    BoundingBoxDimension["height"] = "height";
	    BoundingBoxDimension["left"] = "left";
	    BoundingBoxDimension["right"] = "right";
	    BoundingBoxDimension["top"] = "top";
	    BoundingBoxDimension["bottom"] = "bottom";
	})(BoundingBoxDimension || (BoundingBoxDimension = {}));
	
	var measureWithoutTransform = function (element) {
	    var transform = element.style.transform;
	    element.style.transform = '';
	    var bbox = element.getBoundingClientRect();
	    element.style.transform = transform;
	    return bbox;
	};
	var resolveProp = function (target, props) {
	    return typeof target === 'function' ? target(props) : target;
	};
	
	var interpolate = popmotion.transform.interpolate;
	var singleAxisPointer = function (axis) { return function (from) {
	    var _a;
	    return popmotion.pointer((_a = {},
	        _a[axis] = typeof from === 'string' ? parseFloat(from) : from,
	        _a)).pipe(function (v) { return v[axis]; });
	}; };
	var pointerX = singleAxisPointer('x');
	var pointerY = singleAxisPointer('y');
	var createPointer = function (axisPointerCreator, min, max, measurement) { return function (transitionProps) {
	    var from = transitionProps.from, type = transitionProps.type, dimensions = transitionProps.dimensions, dragBounds = transitionProps.dragBounds;
	    var axisPointer = axisPointerCreator(dimensions.measurementAsPixels(measurement, from, type));
	    var transformQueue = [];
	    if (dragBounds) {
	        var resolvedDragBounds_1 = resolveProp(dragBounds, transitionProps);
	        if (resolvedDragBounds_1[min] !== undefined) {
	            transformQueue.push(function (v) {
	                return Math.max(v, dimensions.measurementAsPixels(measurement, resolvedDragBounds_1[min], type));
	            });
	        }
	        if (resolvedDragBounds_1[max] !== undefined) {
	            transformQueue.push(function (v) {
	                return Math.min(v, dimensions.measurementAsPixels(measurement, resolvedDragBounds_1[max], type));
	            });
	        }
	    }
	    if (type === styleValueTypes.percent) {
	        transformQueue.push(interpolate([0, dimensions.get(measurement)], [0, 100]), function (v) { return v + '%'; });
	    }
	    return transformQueue.length
	        ? axisPointer.pipe.apply(axisPointer, transformQueue) : axisPointer;
	}; };
	var just = function (from) {
	    return popmotion.action(function (_a) {
	        var update = _a.update, complete = _a.complete;
	        update(from);
	        complete();
	    });
	};
	var underDampedSpring = function (_a) {
	    var from = _a.from, velocity = _a.velocity, to = _a.to;
	    return popmotion.spring({
	        from: from,
	        to: to,
	        velocity: velocity,
	        stiffness: 500,
	        damping: 25,
	        restDelta: 0.5,
	        restSpeed: 10
	    });
	};
	var overDampedSpring = function (_a) {
	    var from = _a.from, velocity = _a.velocity, to = _a.to;
	    return popmotion.spring({ from: from, to: to, velocity: velocity, stiffness: 700, damping: to === 0 ? 100 : 35 });
	};
	var linearTween = function (_a) {
	    var from = _a.from, to = _a.to;
	    return popmotion.tween({ from: from, to: to, ease: easing.linear });
	};
	var intelligentTransition = {
	    x: underDampedSpring,
	    y: underDampedSpring,
	    z: underDampedSpring,
	    rotate: underDampedSpring,
	    rotateX: underDampedSpring,
	    rotateY: underDampedSpring,
	    rotateZ: underDampedSpring,
	    scaleX: overDampedSpring,
	    scaleY: overDampedSpring,
	    scale: overDampedSpring,
	    opacity: linearTween,
	    default: popmotion.tween
	};
	var dragAction = __assign({}, intelligentTransition, { x: createPointer(pointerX, 'left', 'right', BoundingBoxDimension.width), y: createPointer(pointerY, 'top', 'bottom', BoundingBoxDimension.height) });
	var justAxis = function (_a) {
	    var from = _a.from;
	    return just(from);
	};
	var intelligentDragEnd = __assign({}, intelligentTransition, { x: justAxis, y: justAxis });
	var defaultTransitions = new Map([
	    ['default', intelligentTransition],
	    ['drag', dragAction],
	    ['dragEnd', intelligentDragEnd]
	]);
	
	var auto = {
	    test: function (v) { return v === 'auto'; },
	    parse: function (v) { return v; }
	};
	var valueTypeTests = [styleValueTypes.number, styleValueTypes.degrees, styleValueTypes.percent, styleValueTypes.px, styleValueTypes.vw, styleValueTypes.vh, auto];
	var testValueType = function (v) { return function (type) { return type.test(v); }; };
	var getValueType = function (v) { return valueTypeTests.find(testValueType(v)); };
	
	var createPassiveValue = function (init, parent, transform) {
	    var raw = popmotion.value(transform(init));
	    parent.raw.subscribe(function (v) { return raw.update(transform(v)); });
	    return { raw: raw };
	};
	var createValue = function (init) {
	    var type = getValueType(init);
	    var raw = popmotion.value(init);
	    return { raw: raw, type: type };
	};
	var addActionDelay = function (delay, transition) {
	    if (delay === void 0) { delay = 0; }
	    return popmotion.chain(popmotion.delay(delay), transition);
	};
	var animationLookup = {
	    tween: popmotion.tween,
	    spring: popmotion.spring,
	    decay: popmotion.decay,
	    keyframes: popmotion.keyframes,
	    physics: popmotion.physics
	};
	var linear = popmotion.easing.linear, easeIn = popmotion.easing.easeIn, easeOut = popmotion.easing.easeOut, easeInOut = popmotion.easing.easeInOut, circIn = popmotion.easing.circIn, circOut = popmotion.easing.circOut, circInOut = popmotion.easing.circInOut, backIn = popmotion.easing.backIn, backOut = popmotion.easing.backOut, backInOut = popmotion.easing.backInOut, anticipate = popmotion.easing.anticipate;
	var easingLookup = {
	    linear: linear,
	    easeIn: easeIn,
	    easeOut: easeOut,
	    easeInOut: easeInOut,
	    circIn: circIn,
	    circOut: circOut,
	    circInOut: circInOut,
	    backIn: backIn,
	    backOut: backOut,
	    backInOut: backInOut,
	    anticipate: anticipate
	};
	var getAction = function (v, _a, _b) {
	    var from = _b.from, to = _b.to, velocity = _b.velocity;
	    var _c = _a.type, type = _c === void 0 ? 'tween' : _c, ease = _a.ease, def = __rest(_a, ["type", "ease"]);
	    heyListen.invariant(animationLookup[type] !== undefined, "Invalid transition type '" + type + "'. Valid transition types are: tween, spring, decay, physics and keyframes.");
	    if (type === 'tween') {
	        var typeOfEase = typeof ease;
	        if (typeOfEase !== 'function') {
	            if (typeOfEase === 'string') {
	                heyListen.invariant(easingLookup[ease] !== undefined, "Invalid easing type '" + ease + "'. popmotion.io/pose/api/config");
	                ease = easingLookup[ease];
	            }
	            else if (Array.isArray(ease)) {
	                heyListen.invariant(ease.length === 4, "Cubic bezier arrays must contain four numerical values.");
	                var x1 = ease[0], y1 = ease[1], x2 = ease[2], y2 = ease[3];
	                ease = popmotion.easing.cubicBezier(x1, y1, x2, y2);
	            }
	        }
	    }
	    var baseProps = type !== 'keyframes'
	        ? {
	            from: from,
	            to: to,
	            velocity: velocity,
	            ease: ease
	        }
	        : { ease: ease };
	    return animationLookup[type](__assign({}, baseProps, def));
	};
	var isAction = function (action) {
	    return typeof action.start !== 'undefined';
	};
	var pose = function (_a) {
	    var transformPose = _a.transformPose, addListenerToValue = _a.addListenerToValue, extendAPI = _a.extendAPI, readValueFromSource = _a.readValueFromSource, posePriority = _a.posePriority, setValueNative = _a.setValueNative;
	    return poseFactory({
	        bindOnChange: function (values, onChange) { return function (key) {
	            if (!values.has(key))
	                return;
	            var raw = values.get(key).raw;
	            raw.subscribe(onChange[key]);
	        }; },
	        readValue: function (_a) {
	            var raw = _a.raw;
	            return raw.get();
	        },
	        setValue: function (_a, to) {
	            var raw = _a.raw;
	            return raw.update(to);
	        },
	        createValue: function (init, key, _a, _b) {
	            var elementStyler = _a.elementStyler;
	            var _c = _b === void 0 ? {} : _b, passiveParent = _c.passiveParent, passiveProps = _c.passiveProps;
	            var val = passiveParent
	                ? createPassiveValue(init, passiveParent, passiveProps)
	                : createValue(init);
	            if (addListenerToValue) {
	                val.raw.subscribe(addListenerToValue(key, elementStyler));
	            }
	            return val;
	        },
	        convertValue: function (raw, key, _a) {
	            var elementStyler = _a.elementStyler;
	            if (addListenerToValue) {
	                raw.subscribe(addListenerToValue(key, elementStyler));
	            }
	            return {
	                raw: raw,
	                type: getValueType(raw.get())
	            };
	        },
	        getTransitionProps: function (_a, to) {
	            var raw = _a.raw, type = _a.type;
	            return ({
	                from: raw.get(),
	                velocity: raw.getVelocity(),
	                to: to,
	                type: type
	            });
	        },
	        resolveTarget: function (_, to) { return to; },
	        selectValueToRead: function (_a) {
	            var raw = _a.raw;
	            return raw;
	        },
	        startAction: function (_a, action, complete) {
	            var raw = _a.raw;
	            var reaction = {
	                update: function (v) { return raw.update(v); },
	                complete: complete
	            };
	            return action.start(reaction);
	        },
	        stopAction: function (action) { return action.stop(); },
	        getInstantTransition: function (_, _a) {
	            var to = _a.to;
	            return just(to);
	        },
	        convertTransitionDefinition: function (val, def, props) {
	            if (isAction(def))
	                return def;
	            var delay = def.delay, min = def.min, max = def.max, round = def.round, remainingDef = __rest(def, ["delay", "min", "max", "round"]);
	            var action = getAction(val, remainingDef, props);
	            var outputPipe = [];
	            if (delay)
	                action = addActionDelay(delay, action);
	            if (min !== undefined)
	                outputPipe.push(function (v) { return Math.max(v, min); });
	            if (max !== undefined)
	                outputPipe.push(function (v) { return Math.min(v, max); });
	            if (round)
	                outputPipe.push(Math.round);
	            return outputPipe.length ? action.pipe.apply(action, outputPipe) : action;
	        },
	        setValueNative: setValueNative,
	        addActionDelay: addActionDelay,
	        defaultTransitions: defaultTransitions,
	        transformPose: transformPose,
	        readValueFromSource: readValueFromSource,
	        posePriority: posePriority,
	        extendAPI: extendAPI
	    });
	};
	
	var createDimensions = (function (element) {
	    var hasMeasured = false;
	    var current = {
	        width: 0,
	        height: 0,
	        top: 0,
	        left: 0,
	        bottom: 0,
	        right: 0
	    };
	    return {
	        get: function (measurement) { return (measurement ? current[measurement] : current); },
	        measure: function () {
	            current = element.getBoundingClientRect();
	            hasMeasured = true;
	            return current;
	        },
	        measurementAsPixels: function (measurement, value, type) {
	            return type === styleValueTypes.percent
	                ? (typeof value === 'string' ? parseFloat(value) : value) /
	                    100 *
	                    current[measurement]
	                : value;
	        },
	        has: function () { return hasMeasured; }
	    };
	});
	
	var makeUIEventApplicator = function (_a) {
	    var startEvents = _a.startEvents, endEvents = _a.endEvents, startPose = _a.startPose, endPose = _a.endPose, startCallback = _a.startCallback, endCallback = _a.endCallback, useDocumentToEnd = _a.useDocumentToEnd, preventDefault = _a.preventDefault;
	    return function (element, activeActions, poser, config) {
	        var startListener = startPose + 'Start';
	        var endListener = startPose + 'End';
	        var eventStartListener = popmotion.listen(element, startEvents).start(function (startEvent) {
	            if (preventDefault)
	                startEvent.preventDefault();
	            poser.set(startPose);
	            if (startCallback && config[startCallback])
	                config[startCallback](startEvent);
	            var eventEndListener = popmotion.listen(useDocumentToEnd ? document.documentElement : element, endEvents + (useDocumentToEnd ? ' mouseenter' : '')).start(function (endEvent) {
	                if (useDocumentToEnd &&
	                    endEvent.type === 'mouseenter' &&
	                    endEvent.buttons === 1) {
	                    return;
	                }
	                if (preventDefault)
	                    endEvent.preventDefault();
	                activeActions.get(endListener).stop();
	                poser.unset(startPose);
	                poser.set(endPose);
	                if (endCallback && config[endCallback])
	                    config[endCallback](endEvent);
	            });
	            activeActions.set(endListener, eventEndListener);
	        });
	        activeActions.set(startListener, eventStartListener);
	    };
	};
	var events = {
	    draggable: makeUIEventApplicator({
	        startEvents: 'mousedown touchstart',
	        endEvents: 'mouseup touchend',
	        startPose: 'drag',
	        endPose: 'dragEnd',
	        startCallback: 'onDragStart',
	        endCallback: 'onDragEnd',
	        useDocumentToEnd: true,
	        preventDefault: true
	    }),
	    hoverable: makeUIEventApplicator({
	        startEvents: 'mouseenter',
	        endEvents: 'mouseleave',
	        startPose: 'hover',
	        endPose: 'hoverEnd'
	    }),
	    focusable: makeUIEventApplicator({
	        startEvents: 'focus',
	        endEvents: 'blur',
	        startPose: 'focus',
	        endPose: 'blur'
	    }),
	    pressable: makeUIEventApplicator({
	        startEvents: 'mousedown touchstart',
	        endEvents: 'mouseup touchend',
	        startPose: 'press',
	        endPose: 'pressEnd',
	        startCallback: 'onPressStart',
	        endCallback: 'onPressEnd',
	        useDocumentToEnd: true
	    })
	};
	var eventKeys = Object.keys(events);
	var appendEventListeners = (function (element, activeActions, poser, _a) {
	    var props = _a.props;
	    return eventKeys.forEach(function (key) {
	        if (props[key])
	            events[key](element, activeActions, poser, props);
	    });
	});
	
	var ORIGIN_START = 0;
	var ORIGIN_CENTER = '50%';
	var ORIGIN_END = '100%';
	var findCenter = function (_a) {
	    var top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left;
	    return ({
	        x: (left + right) / 2,
	        y: (top + bottom) / 2
	    });
	};
	var positionalProps = ['width', 'height', 'top', 'left', 'bottom', 'right'];
	var positionalPropsDict = new Set(positionalProps);
	var checkPositionalProp = function (key) { return positionalPropsDict.has(key); };
	var hasPositionalProps = function (pose) {
	    return Object.keys(pose).some(checkPositionalProp);
	};
	var isFlipPose = function (flip, key, state) {
	    return state.props.element instanceof HTMLElement &&
	        (flip === true || key === 'flip');
	};
	var setValue = function (_a, key, to) {
	    var values = _a.values, props = _a.props;
	    if (values.has(key)) {
	        var raw = values.get(key).raw;
	        raw.update(to);
	        raw.update(to);
	    }
	    else {
	        values.set(key, {
	            raw: popmotion.value(to, function (v) { return props.elementStyler.set(key, v); })
	        });
	    }
	};
	var explicitlyFlipPose = function (state, nextPose) {
	    var _a = state.props, dimensions = _a.dimensions, elementStyler = _a.elementStyler;
	    dimensions.measure();
	    var width = nextPose.width, height = nextPose.height, top = nextPose.top, left = nextPose.left, bottom = nextPose.bottom, right = nextPose.right, position = nextPose.position, remainingPose = __rest(nextPose, ["width", "height", "top", "left", "bottom", "right", "position"]);
	    var propsToSet = positionalProps.concat('position').reduce(function (acc, key) {
	        if (nextPose[key] !== undefined) {
	            acc[key] = resolveProp(nextPose[key], state.props);
	        }
	        return acc;
	    }, {});
	    elementStyler.set(propsToSet).render();
	    return implicitlyFlipPose(state, remainingPose);
	};
	var implicitlyFlipPose = function (state, nextPose) {
	    var _a = state.props, dimensions = _a.dimensions, element = _a.element, elementStyler = _a.elementStyler;
	    if (!dimensions.has())
	        return {};
	    var prev = dimensions.get();
	    var next = measureWithoutTransform(element);
	    var originX = prev.left === next.left
	        ? ORIGIN_START
	        : prev.right === next.right ? ORIGIN_END : ORIGIN_CENTER;
	    var originY = prev.top === next.top
	        ? ORIGIN_START
	        : prev.bottom === next.bottom ? ORIGIN_END : ORIGIN_CENTER;
	    elementStyler.set({ originX: originX, originY: originY });
	    var flipPoseProps = {};
	    if (prev.width !== next.width) {
	        setValue(state, 'scaleX', prev.width / next.width);
	        flipPoseProps.scaleX = 1;
	    }
	    if (prev.height !== next.height) {
	        setValue(state, 'scaleY', prev.height / next.height);
	        flipPoseProps.scaleY = 1;
	    }
	    var prevCenter = findCenter(prev);
	    var nextCenter = findCenter(next);
	    if (originX === ORIGIN_CENTER) {
	        setValue(state, 'x', prevCenter.x - nextCenter.x);
	        flipPoseProps.x = 0;
	    }
	    if (originY === ORIGIN_CENTER) {
	        setValue(state, 'y', prevCenter.y - nextCenter.y);
	        flipPoseProps.y = 0;
	    }
	    elementStyler.render();
	    return __assign({}, nextPose, flipPoseProps);
	};
	var flipPose = function (props, nextPose) {
	    return hasPositionalProps(nextPose)
	        ? explicitlyFlipPose(props, nextPose)
	        : implicitlyFlipPose(props, nextPose);
	};
	
	var getPosFromMatrix = function (matrix, pos) {
	    return parseFloat(matrix.split(', ')[pos]);
	};
	var getTranslateFromMatrix = function (pos2, pos3) { return function (element, bbox, _a) {
	    var transform = _a.transform;
	    if (transform === 'none')
	        return 0;
	    var matrix3d = transform.match(/^matrix3d\((.+)\)$/);
	    if (matrix3d)
	        return getPosFromMatrix(matrix3d[1], pos3);
	    return getPosFromMatrix(transform.match(/^matrix\((.+)\)$/)[1], pos2);
	}; };
	var positionalValues = {
	    width: function (element, _a) {
	        var width = _a.width;
	        return width;
	    },
	    height: function (element, _a) {
	        var height = _a.height;
	        return height;
	    },
	    top: function (element, bbox, _a) {
	        var top = _a.top;
	        return parseFloat(top);
	    },
	    left: function (element, bbox, _a) {
	        var left = _a.left;
	        return parseFloat(left);
	    },
	    bottom: function (element, _a, _b) {
	        var height = _a.height;
	        var top = _b.top;
	        return parseFloat(top) + height;
	    },
	    right: function (element, _a, _b) {
	        var width = _a.width;
	        var left = _b.left;
	        return parseFloat(left) + width;
	    },
	    x: getTranslateFromMatrix(4, 13),
	    y: getTranslateFromMatrix(5, 14)
	};
	var isPositionalKey = function (v) { return positionalValues[v] !== undefined; };
	var isPositional = function (pose) {
	    return Object.keys(pose).some(isPositionalKey);
	};
	var convertPositionalUnits = function (state, pose) {
	    var values = state.values, props = state.props;
	    var element = props.element, elementStyler = props.elementStyler;
	    var positionalPoseKeys = Object.keys(pose).filter(isPositionalKey);
	    var changedPositionalKeys = [];
	    var elementComputedStyle = getComputedStyle(element);
	    positionalPoseKeys.forEach(function (key) {
	        var value = values.get(key);
	        var fromValueType = getValueType(value.raw.get());
	        var to = resolveProp(pose[key], props);
	        var toValueType = getValueType(to);
	        if (fromValueType !== toValueType) {
	            changedPositionalKeys.push(key);
	            pose.applyAtEnd = pose.applyAtEnd || {};
	            pose.applyAtEnd[key] = pose[key];
	            setValue(state, key, to);
	        }
	    });
	    if (!changedPositionalKeys.length)
	        return pose;
	    var originBbox = element.getBoundingClientRect();
	    var top = elementComputedStyle.top, left = elementComputedStyle.left, bottom = elementComputedStyle.bottom, right = elementComputedStyle.right, transform = elementComputedStyle.transform;
	    var originComputedStyle = { top: top, left: left, bottom: bottom, right: right, transform: transform };
	    elementStyler.render();
	    var targetBbox = element.getBoundingClientRect();
	    var newPose = __assign({}, pose);
	    changedPositionalKeys.forEach(function (key) {
	        setValue(state, key, positionalValues[key](element, originBbox, originComputedStyle));
	        newPose[key] = positionalValues[key](element, targetBbox, elementComputedStyle);
	    });
	    elementStyler.render();
	    return newPose;
	};
	
	var dragPoses = function (draggable) {
	    var drag = {
	        preTransition: function (_a) {
	            var dimensions = _a.dimensions;
	            return dimensions.measure();
	        }
	    };
	    var dragEnd = {};
	    if (draggable === true || draggable === 'x')
	        drag.x = dragEnd.x = 0;
	    if (draggable === true || draggable === 'y')
	        drag.y = dragEnd.y = 0;
	    return { drag: drag, dragEnd: dragEnd };
	};
	var createPoseConfig = function (element, _a) {
	    var onDragStart = _a.onDragStart, onDragEnd = _a.onDragEnd, onPressStart = _a.onPressStart, onPressEnd = _a.onPressEnd, draggable = _a.draggable, hoverable = _a.hoverable, focusable = _a.focusable, pressable = _a.pressable, dragBounds = _a.dragBounds, config = __rest(_a, ["onDragStart", "onDragEnd", "onPressStart", "onPressEnd", "draggable", "hoverable", "focusable", "pressable", "dragBounds"]);
	    var poseConfig = __assign({ flip: {} }, config, { props: __assign({}, config.props, { onDragStart: onDragStart,
	            onDragEnd: onDragEnd,
	            onPressStart: onPressStart,
	            onPressEnd: onPressEnd,
	            dragBounds: dragBounds,
	            draggable: draggable,
	            hoverable: hoverable,
	            focusable: focusable,
	            pressable: pressable,
	            element: element, elementStyler: popmotion.styler(element, { preparseOutput: false }), dimensions: createDimensions(element) }) });
	    if (draggable) {
	        var _b = dragPoses(draggable), drag = _b.drag, dragEnd = _b.dragEnd;
	        poseConfig.drag = __assign({}, poseConfig.drag, drag);
	        poseConfig.dragEnd = __assign({}, poseConfig.dragEnd, dragEnd);
	    }
	    return poseConfig;
	};
	var domPose = pose({
	    posePriority: ['drag', 'press', 'focus', 'hover'],
	    transformPose: function (_a, name, state) {
	        var flip = _a.flip, pose$$1 = __rest(_a, ["flip"]);
	        if (isFlipPose(flip, name, state)) {
	            return flipPose(state, pose$$1);
	        }
	        else if (isPositional(pose$$1)) {
	            return convertPositionalUnits(state, pose$$1);
	        }
	        return pose$$1;
	    },
	    addListenerToValue: function (key, elementStyler) { return function (v) { return elementStyler.set(key, v); }; },
	    readValueFromSource: function (key, _a) {
	        var elementStyler = _a.elementStyler, dragBounds = _a.dragBounds;
	        var value = elementStyler.get(key);
	        if (dragBounds && (key === 'x' || key === 'y')) {
	            var bound = key === 'x'
	                ? dragBounds.left || dragBounds.right
	                : dragBounds.top || dragBounds.bottom;
	            if (bound) {
	                var boundType = getValueType(bound);
	                value = boundType.transform(value);
	            }
	        }
	        return isNaN(value) ? value : parseFloat(value);
	    },
	    setValueNative: function (key, to, _a) {
	        var elementStyler = _a.elementStyler;
	        return elementStyler.set(key, to);
	    },
	    extendAPI: function (api, _a, config) {
	        var props = _a.props, activeActions = _a.activeActions;
	        var measure = props.dimensions.measure;
	        var poserApi = __assign({}, api, { addChild: function (element, childConfig) {
	                return api._addChild(createPoseConfig(element, childConfig), domPose);
	            }, measure: measure, flip: function (op) {
	                if (op) {
	                    measure();
	                    op();
	                }
	                return api.set('flip');
	            } });
	        props.elementStyler.render();
	        appendEventListeners(props.element, activeActions, poserApi, config);
	        return poserApi;
	    }
	});
	var domPose$1 = (function (element, config) {
	    return domPose(createPoseConfig(element, config));
	});
	
	exports.default = domPose$1;


/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var __rest = (this && this.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
	            t[p[i]] = s[p[i]];
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var chainable_1 = __webpack_require__(41);
	var observer_1 = __webpack_require__(48);
	var Action = (function (_super) {
	    __extends(Action, _super);
	    function Action() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Action.prototype.create = function (props) {
	        return new Action(props);
	    };
	    Action.prototype.start = function (observerCandidate) {
	        if (observerCandidate === void 0) { observerCandidate = {}; }
	        var isComplete = false;
	        var subscription = {
	            stop: function () { return undefined; }
	        };
	        var _a = this.props, init = _a.init, observerProps = __rest(_a, ["init"]);
	        var observer = observer_1.default(observerCandidate, observerProps, function () {
	            isComplete = true;
	            subscription.stop();
	        });
	        var api = init(observer);
	        subscription = api
	            ? __assign({}, subscription, api) : subscription;
	        if (observerCandidate.registerParent) {
	            observerCandidate.registerParent(subscription);
	        }
	        if (isComplete)
	            subscription.stop();
	        return subscription;
	    };
	    return Action;
	}(chainable_1.default));
	exports.Action = Action;
	exports.default = function (init) { return new Action({ init: init }); };
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var style_value_types_1 = __webpack_require__(7);
	var composite_1 = __webpack_require__(28);
	var parallel_1 = __webpack_require__(19);
	var transformers_1 = __webpack_require__(11);
	var isColor = style_value_types_1.color.test;
	var convertToColorAction = function (init, props) { return (typeof props.from === 'string' && isColor(props.from) &&
	    typeof props.to === 'string' && isColor(props.to)) ? init(__assign({}, props, { from: 0, to: 1 })).pipe(transformers_1.blendColor(props.from, props.to), style_value_types_1.color.transform)
	    : init(props); };
	var createVectorTests = function (typeTests) {
	    var testNames = Object.keys(typeTests);
	    return {
	        getVectorKeys: function (props) { return testNames.reduce(function (vectorKeys, key) {
	            if (props[key] !== undefined && !typeTests[key](props[key])) {
	                vectorKeys.push(key);
	            }
	            return vectorKeys;
	        }, []); },
	        test: function (props) { return props && testNames.reduce(function (isVector, key) {
	            return isVector || (props[key] !== undefined && !typeTests[key](props[key]));
	        }, false); }
	    };
	};
	var reduceArrayValue = function (i) { return function (props, key) {
	    props[key] = props[key][i];
	    return props;
	}; };
	var createArrayVector = function (init, props, vectorKeys) {
	    var firstVectorKey = vectorKeys[0];
	    var actionList = props[firstVectorKey].map(function (v, i) {
	        return convertToColorAction(init, vectorKeys.reduce(reduceArrayValue(i), __assign({}, props)));
	    });
	    return parallel_1.default.apply(void 0, actionList);
	};
	var reduceObjectValue = function (key) { return function (props, propKey) {
	    props[propKey] = props[propKey][key];
	    return props;
	}; };
	var createObjectVector = function (init, props, vectorKeys) {
	    var firstVectorKey = vectorKeys[0];
	    var actionMap = Object.keys(props[firstVectorKey]).reduce(function (map, key) {
	        map[key] = convertToColorAction(init, vectorKeys.reduce(reduceObjectValue(key), __assign({}, props)));
	        return map;
	    }, {});
	    return composite_1.default(actionMap);
	};
	var createColorVector = function (init, props) { return convertToColorAction(init, props); };
	var vectorAction = function (init, typeTests) {
	    var _a = createVectorTests(typeTests), test = _a.test, getVectorKeys = _a.getVectorKeys;
	    return function (props) {
	        var isVector = test(props);
	        if (!isVector)
	            return init(props);
	        var vectorKeys = getVectorKeys(props);
	        var testKey = vectorKeys[0];
	        var testProp = props[testKey];
	        if (Array.isArray(testProp)) {
	            return createArrayVector(init, props, vectorKeys);
	        }
	        else if (typeof testProp === 'string' && isColor(testProp)) {
	            return createColorVector(init, props, vectorKeys);
	        }
	        else {
	            return createObjectVector(init, props, vectorKeys);
	        }
	    };
	};
	exports.default = vectorAction;
	//# sourceMappingURL=vector.js.map

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var framesync_1 = __webpack_require__(4);
	var style_value_types_1 = __webpack_require__(7);
	var action_1 = __webpack_require__(2);
	var vector_1 = __webpack_require__(18);
	var every_frame_1 = __webpack_require__(16);
	var decay = function (props) {
	    if (props === void 0) { props = {}; }
	    return action_1.default(function (_a) {
	        var complete = _a.complete, update = _a.update;
	        var _b = props.velocity, velocity = _b === void 0 ? 0 : _b, _c = props.from, from = _c === void 0 ? 0 : _c, _d = props.power, power = _d === void 0 ? 0.8 : _d, _e = props.timeConstant, timeConstant = _e === void 0 ? 350 : _e, _f = props.restDelta, restDelta = _f === void 0 ? 0.5 : _f, modifyTarget = props.modifyTarget;
	        var elapsed = 0;
	        var amplitude = power * velocity;
	        var idealTarget = Math.round(from + amplitude);
	        var target = (typeof modifyTarget === 'undefined')
	            ? idealTarget
	            : modifyTarget(idealTarget);
	        var timer = every_frame_1.default().start(function () {
	            elapsed += framesync_1.timeSinceLastFrame();
	            var delta = -amplitude * Math.exp(-elapsed / timeConstant);
	            var isMoving = (delta > restDelta || delta < -restDelta);
	            var current = isMoving ? target + delta : target;
	            update(current);
	            if (!isMoving) {
	                timer.stop();
	                complete();
	            }
	        });
	        return {
	            stop: function () { return timer.stop(); }
	        };
	    });
	};
	exports.default = vector_1.default(decay, {
	    from: style_value_types_1.number.test,
	    modifyTarget: function (func) { return typeof func === 'function'; },
	    velocity: style_value_types_1.number.test
	});
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var framesync_1 = __webpack_require__(4);
	var action_1 = __webpack_require__(2);
	var frame = function () { return action_1.default(function (_a) {
	    var update = _a.update;
	    var isActive = true;
	    var startTime = framesync_1.currentTime();
	    var nextFrame = function () {
	        if (!isActive)
	            return;
	        update(Math.max(framesync_1.currentFrameTime() - startTime, 0));
	        framesync_1.onFrameUpdate(nextFrame);
	    };
	    framesync_1.onFrameUpdate(nextFrame);
	    return {
	        stop: function () { return isActive = false; }
	    };
	}); };
	exports.default = frame;
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var __rest = (this && this.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
	            t[p[i]] = s[p[i]];
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var calc_1 = __webpack_require__(3);
	var easing_1 = __webpack_require__(10);
	var transformers_1 = __webpack_require__(11);
	var tween_1 = __webpack_require__(39);
	var scrubber_1 = __webpack_require__(40);
	var clampProgress = transformers_1.clamp(0, 1);
	var defaultEasings = function (values, easing) {
	    return values.map(function () { return easing || easing_1.easeOut; }).splice(0, values.length - 1);
	};
	var defaultTimings = function (values) {
	    var numValues = values.length;
	    return values.map(function (value, i) { return (i !== 0) ? i / (numValues - 1) : 0; });
	};
	var interpolateScrubbers = function (input, scrubbers, update) {
	    var rangeLength = input.length;
	    var finalInputIndex = rangeLength - 1;
	    var finalScrubberIndex = finalInputIndex - 1;
	    var subs = scrubbers.map(function (scrub) { return scrub.start(update); });
	    return function (v) {
	        if (v <= input[0]) {
	            subs[0].seek(0);
	        }
	        if (v >= input[finalInputIndex]) {
	            subs[finalScrubberIndex].seek(1);
	        }
	        var i = 1;
	        for (; i < rangeLength; i++) {
	            if (input[i] > v || i === finalInputIndex)
	                break;
	        }
	        var progressInRange = calc_1.getProgressFromValue(input[i - 1], input[i], v);
	        subs[i - 1].seek(clampProgress(progressInRange));
	    };
	};
	var keyframes = function (_a) {
	    var easings = _a.easings, _b = _a.ease, ease = _b === void 0 ? easing_1.linear : _b, times = _a.times, values = _a.values, tweenProps = __rest(_a, ["easings", "ease", "times", "values"]);
	    easings = Array.isArray(easings)
	        ? easings
	        : defaultEasings(values, easings);
	    times = times || defaultTimings(values);
	    var scrubbers = easings.map(function (easing, i) { return scrubber_1.default({
	        from: values[i],
	        to: values[i + 1],
	        ease: easing
	    }); });
	    return tween_1.default(__assign({}, tweenProps, { ease: ease })).applyMiddleware(function (update) { return interpolateScrubbers(times, scrubbers, update); });
	};
	exports.default = keyframes;
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var framesync_1 = __webpack_require__(4);
	var style_value_types_1 = __webpack_require__(7);
	var action_1 = __webpack_require__(2);
	var vector_1 = __webpack_require__(18);
	var calc_1 = __webpack_require__(3);
	var every_frame_1 = __webpack_require__(16);
	var physics = function (props) {
	    if (props === void 0) { props = {}; }
	    return action_1.default(function (_a) {
	        var complete = _a.complete, update = _a.update;
	        var _b = props.acceleration, acceleration = _b === void 0 ? 0 : _b, _c = props.friction, friction = _c === void 0 ? 0 : _c, _d = props.velocity, velocity = _d === void 0 ? 0 : _d, springStrength = props.springStrength, to = props.to;
	        var _e = props.restSpeed, restSpeed = _e === void 0 ? 0.001 : _e, _f = props.from, from = _f === void 0 ? 0 : _f;
	        var current = from;
	        var timer = every_frame_1.default().start(function () {
	            var elapsed = Math.max(framesync_1.timeSinceLastFrame(), 16);
	            if (acceleration)
	                velocity += calc_1.speedPerFrame(acceleration, elapsed);
	            if (friction)
	                velocity *= Math.pow((1 - friction), (elapsed / 100));
	            if (springStrength !== undefined && to !== undefined) {
	                var distanceToTarget = to - current;
	                velocity += distanceToTarget * calc_1.speedPerFrame(springStrength, elapsed);
	            }
	            current += calc_1.speedPerFrame(velocity, elapsed);
	            update(current);
	            var isComplete = (restSpeed !== false && (!velocity || Math.abs(velocity) <= restSpeed));
	            if (isComplete) {
	                timer.stop();
	                complete();
	            }
	        });
	        return {
	            set: function (v) {
	                current = v;
	                return this;
	            },
	            setAcceleration: function (v) {
	                acceleration = v;
	                return this;
	            },
	            setFriction: function (v) {
	                friction = v;
	                return this;
	            },
	            setSpringStrength: function (v) {
	                springStrength = v;
	                return this;
	            },
	            setSpringTarget: function (v) {
	                to = v;
	                return this;
	            },
	            setVelocity: function (v) {
	                velocity = v;
	                return this;
	            },
	            stop: function () { return timer.stop(); }
	        };
	    });
	};
	exports.default = vector_1.default(physics, {
	    acceleration: style_value_types_1.number.test,
	    friction: style_value_types_1.number.test,
	    velocity: style_value_types_1.number.test,
	    from: style_value_types_1.number.test,
	    to: style_value_types_1.number.test,
	    springStrength: style_value_types_1.number.test
	});
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var framesync_1 = __webpack_require__(4);
	var style_value_types_1 = __webpack_require__(7);
	var action_1 = __webpack_require__(2);
	var vector_1 = __webpack_require__(18);
	var calc_1 = __webpack_require__(3);
	var every_frame_1 = __webpack_require__(16);
	var spring = function (props) {
	    if (props === void 0) { props = {}; }
	    return action_1.default(function (_a) {
	        var update = _a.update, complete = _a.complete;
	        var _b = props.velocity, velocity = _b === void 0 ? 0.0 : _b;
	        var _c = props.from, from = _c === void 0 ? 0.0 : _c, _d = props.to, to = _d === void 0 ? 0.0 : _d, _e = props.stiffness, stiffness = _e === void 0 ? 100 : _e, _f = props.damping, damping = _f === void 0 ? 10 : _f, _g = props.mass, mass = _g === void 0 ? 1.0 : _g, _h = props.restSpeed, restSpeed = _h === void 0 ? 0.01 : _h, _j = props.restDelta, restDelta = _j === void 0 ? 0.01 : _j;
	        var initialVelocity = velocity ? -(velocity / 1000) : 0.0;
	        var t = 0;
	        var delta = to - from;
	        var position = from;
	        var prevPosition = position;
	        var springTimer = every_frame_1.default().start(function () {
	            var timeDelta = framesync_1.timeSinceLastFrame();
	            t += timeDelta;
	            var dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
	            var angularFreq = Math.sqrt(stiffness / mass) / 1000;
	            prevPosition = position;
	            if (dampingRatio < 1) {
	                var envelope = Math.exp(-dampingRatio * angularFreq * t);
	                var expoDecay = angularFreq * Math.sqrt(1.0 - dampingRatio * dampingRatio);
	                position = to - envelope * ((initialVelocity + dampingRatio * angularFreq * delta)
	                    / expoDecay * Math.sin(expoDecay * t)
	                    + delta * Math.cos(expoDecay * t));
	            }
	            else {
	                var envelope = Math.exp(-angularFreq * t);
	                position = to - envelope * (delta + (initialVelocity + angularFreq * delta) * t);
	            }
	            velocity = calc_1.speedPerSecond(position - prevPosition, timeDelta);
	            var isBelowVelocityThreshold = Math.abs(velocity) <= restSpeed;
	            var isBelowDisplacementThreshold = Math.abs(to - position) <= restDelta;
	            if (isBelowVelocityThreshold && isBelowDisplacementThreshold) {
	                position = to;
	                update(position);
	                springTimer.stop();
	                complete();
	            }
	            else {
	                update(position);
	            }
	        });
	        return {
	            stop: function () { return springTimer.stop(); }
	        };
	    });
	};
	exports.default = vector_1.default(spring, {
	    from: style_value_types_1.number.test,
	    to: style_value_types_1.number.test,
	    stiffness: style_value_types_1.number.test,
	    damping: style_value_types_1.number.test,
	    mass: style_value_types_1.number.test,
	    velocity: style_value_types_1.number.test
	});
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var keyframes_1 = __webpack_require__(38);
	var easing_1 = __webpack_require__(10);
	var composite_1 = __webpack_require__(28);
	var DEFAULT_DURATION = 300;
	var flattenTimings = function (instructions) {
	    var flatInstructions = [];
	    var lastArg = instructions[instructions.length - 1];
	    var isStaggered = typeof lastArg === 'number';
	    var staggerDelay = isStaggered ? lastArg : 0;
	    var segments = isStaggered ? instructions.slice(0, -1) : instructions;
	    var numSegments = segments.length;
	    var offset = 0;
	    segments.forEach(function (item, i) {
	        flatInstructions.push(item);
	        if (i !== numSegments - 1) {
	            var duration = item.duration || DEFAULT_DURATION;
	            offset += staggerDelay;
	            flatInstructions.push("-" + (duration - offset));
	        }
	    });
	    return flatInstructions;
	};
	var flattenArrayInstructions = function (instructions, instruction) {
	    Array.isArray(instruction)
	        ? instructions.push.apply(instructions, flattenTimings(instruction)) : instructions.push(instruction);
	    return instructions;
	};
	var convertDefToProps = function (props, def, i) {
	    var duration = props.duration, easings = props.easings, times = props.times, values = props.values;
	    var numValues = values.length;
	    var prevTimeTo = times[numValues - 1];
	    var timeFrom = def.at === 0 ? 0 : def.at / duration;
	    var timeTo = (def.at + def.duration) / duration;
	    if (i === 0) {
	        values.push(def.from);
	        times.push(timeFrom);
	    }
	    else {
	        if (prevTimeTo !== timeFrom) {
	            if (def.from !== undefined) {
	                values.push(values[numValues - 1]);
	                times.push(timeFrom);
	                easings.push(easing_1.linear);
	            }
	            var from = def.from !== undefined ? def.from : values[numValues - 1];
	            values.push(from);
	            times.push(timeFrom);
	            easings.push(easing_1.linear);
	        }
	        else if (def.from !== undefined) {
	            values.push(def.from);
	            times.push(timeFrom);
	            easings.push(easing_1.linear);
	        }
	    }
	    values.push(def.to);
	    times.push(timeTo);
	    easings.push(def.ease || easing_1.easeInOut);
	    return props;
	};
	var timeline = function (instructions, _a) {
	    var _b = _a === void 0 ? {} : _a, duration = _b.duration, elapsed = _b.elapsed, ease = _b.ease, loop = _b.loop, flip = _b.flip, yoyo = _b.yoyo;
	    var playhead = 0;
	    var calculatedDuration = 0;
	    var flatInstructions = instructions.reduce(flattenArrayInstructions, []);
	    var animationDefs = [];
	    flatInstructions.forEach(function (instruction) {
	        if (typeof instruction === 'string') {
	            playhead += parseFloat(instruction);
	        }
	        else if (typeof instruction === 'number') {
	            playhead = instruction;
	        }
	        else {
	            var def = __assign({}, instruction, { at: playhead });
	            def.duration = def.duration === undefined ? DEFAULT_DURATION : def.duration;
	            animationDefs.push(def);
	            playhead += def.duration;
	            calculatedDuration = Math.max(calculatedDuration, def.at + def.duration);
	        }
	    });
	    var tracks = {};
	    var numDefs = animationDefs.length;
	    for (var i = 0; i < numDefs; i++) {
	        var def = animationDefs[i];
	        var track = def.track;
	        if (track === undefined) {
	            throw new Error('No track defined');
	        }
	        if (!tracks.hasOwnProperty(track))
	            tracks[track] = [];
	        tracks[track].push(def);
	    }
	    var trackKeyframes = {};
	    for (var key in tracks) {
	        if (tracks.hasOwnProperty(key)) {
	            var keyframeProps = tracks[key].reduce(convertDefToProps, {
	                duration: calculatedDuration,
	                easings: [],
	                times: [],
	                values: []
	            });
	            trackKeyframes[key] = keyframes_1.default(__assign({}, keyframeProps, { duration: duration || calculatedDuration, ease: ease,
	                elapsed: elapsed,
	                loop: loop,
	                yoyo: yoyo,
	                flip: flip }));
	        }
	    }
	    return composite_1.default(trackKeyframes);
	};
	exports.default = timeline;
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var framesync_1 = __webpack_require__(4);
	var action_1 = __webpack_require__(2);
	var calc_1 = __webpack_require__(3);
	var easing_1 = __webpack_require__(10);
	var transformers_1 = __webpack_require__(11);
	var every_frame_1 = __webpack_require__(16);
	var scrubber_1 = __webpack_require__(40);
	var clampProgress = transformers_1.clamp(0, 1);
	var tween = function (props) {
	    if (props === void 0) { props = {}; }
	    return action_1.default(function (_a) {
	        var update = _a.update, complete = _a.complete;
	        var _b = props.duration, duration = _b === void 0 ? 300 : _b, _c = props.ease, ease = _c === void 0 ? easing_1.easeOut : _c, _d = props.flip, flip = _d === void 0 ? 0 : _d, _e = props.loop, loop = _e === void 0 ? 0 : _e, _f = props.yoyo, yoyo = _f === void 0 ? 0 : _f;
	        var _g = props.from, from = _g === void 0 ? 0 : _g, _h = props.to, to = _h === void 0 ? 1 : _h, _j = props.elapsed, elapsed = _j === void 0 ? 0 : _j, _k = props.playDirection, playDirection = _k === void 0 ? 1 : _k, _l = props.flipCount, flipCount = _l === void 0 ? 0 : _l, _m = props.yoyoCount, yoyoCount = _m === void 0 ? 0 : _m, _o = props.loopCount, loopCount = _o === void 0 ? 0 : _o;
	        var playhead = scrubber_1.default({ from: from, to: to, ease: ease }).start(update);
	        var progress = 0;
	        var tweenTimer;
	        var isActive = false;
	        var reverseTween = function () { return playDirection *= -1; };
	        var isTweenComplete = function () {
	            var isComplete = (playDirection === 1)
	                ? isActive && elapsed >= duration
	                : isActive && elapsed <= 0;
	            if (!isComplete)
	                return false;
	            if (isComplete && !loop && !flip && !yoyo)
	                return true;
	            var isStepTaken = false;
	            if (loop && loopCount < loop) {
	                elapsed = 0;
	                loopCount++;
	                isStepTaken = true;
	            }
	            else if (flip && flipCount < flip) {
	                elapsed = duration - elapsed;
	                _a = [to, from], from = _a[0], to = _a[1];
	                playhead = scrubber_1.default({ from: from, to: to, ease: ease }).start(update);
	                flipCount++;
	                isStepTaken = true;
	            }
	            else if (yoyo && yoyoCount < yoyo) {
	                reverseTween();
	                yoyoCount++;
	                isStepTaken = true;
	            }
	            return !isStepTaken;
	            var _a;
	        };
	        var updateTween = function () {
	            progress = clampProgress(calc_1.getProgressFromValue(0, duration, elapsed));
	            playhead.seek(progress);
	        };
	        var startTimer = function () {
	            isActive = true;
	            tweenTimer = every_frame_1.default().start(function () {
	                elapsed += framesync_1.timeSinceLastFrame() * playDirection;
	                updateTween();
	                if (isTweenComplete() && complete) {
	                    tweenTimer.stop();
	                    framesync_1.onFrameUpdate(complete, true);
	                }
	            });
	        };
	        var stopTimer = function () {
	            isActive = false;
	            if (tweenTimer)
	                tweenTimer.stop();
	        };
	        startTimer();
	        return {
	            isActive: function () { return isActive; },
	            getElapsed: function () { return transformers_1.clamp(0, duration)(elapsed); },
	            getProgress: function () { return progress; },
	            stop: function () {
	                stopTimer();
	            },
	            pause: function () {
	                stopTimer();
	                return this;
	            },
	            resume: function () {
	                startTimer();
	                return this;
	            },
	            seek: function (newProgress) {
	                elapsed = calc_1.getValueFromProgress(0, duration, newProgress);
	                framesync_1.onFrameUpdate(updateTween, true);
	                return this;
	            },
	            reverse: function () {
	                reverseTween();
	                return this;
	            }
	        };
	    });
	};
	exports.default = tween;
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var style_value_types_1 = __webpack_require__(7);
	var action_1 = __webpack_require__(2);
	var vector_1 = __webpack_require__(18);
	var calc_1 = __webpack_require__(3);
	var easing_1 = __webpack_require__(10);
	var scrubber = function (_a) {
	    var _b = _a.from, from = _b === void 0 ? 0 : _b, _c = _a.to, to = _c === void 0 ? 1 : _c, _d = _a.ease, ease = _d === void 0 ? easing_1.linear : _d;
	    return action_1.default(function (_a) {
	        var update = _a.update;
	        return ({
	            seek: function (progress) { return update(progress); }
	        });
	    }).pipe(ease, function (v) { return calc_1.getValueFromProgress(from, to, v); });
	};
	exports.default = vector_1.default(scrubber, {
	    ease: function (func) { return typeof func === 'function'; },
	    from: style_value_types_1.number.test,
	    to: style_value_types_1.number.test
	});
	//# sourceMappingURL=scrubber.js.map

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var isNum = function (v) { return typeof v === 'number'; };
	exports.isPoint = function (point) {
	    return point.x !== undefined && point.y !== undefined;
	};
	exports.isPoint3D = function (point) {
	    return point.z !== undefined;
	};
	var toDecimal = function (num, precision) {
	    if (precision === void 0) { precision = 2; }
	    precision = Math.pow(10, precision);
	    return Math.round(num * precision) / precision;
	};
	var ZERO_POINT = {
	    x: 0,
	    y: 0,
	    z: 0
	};
	var distance1D = function (a, b) { return Math.abs(a - b); };
	exports.angle = function (a, b) {
	    if (b === void 0) { b = ZERO_POINT; }
	    return exports.radiansToDegrees(Math.atan2(b.y - a.y, b.x - a.x));
	};
	exports.degreesToRadians = function (degrees) { return degrees * Math.PI / 180; };
	exports.dilate = function (a, b, dilation) { return a + ((b - a) * dilation); };
	exports.distance = function (a, b) {
	    if (b === void 0) { b = ZERO_POINT; }
	    if (isNum(a) && isNum(b)) {
	        return distance1D(a, b);
	    }
	    else if (exports.isPoint(a) && exports.isPoint(b)) {
	        var xDelta = distance1D(a.x, b.x);
	        var yDelta = distance1D(a.y, b.y);
	        var zDelta = (exports.isPoint3D(a) && exports.isPoint3D(b)) ? distance1D(a.z, b.z) : 0;
	        return Math.sqrt((Math.pow(xDelta, 2)) + (Math.pow(yDelta, 2)) + (Math.pow(zDelta, 2)));
	    }
	    return 0;
	};
	exports.getProgressFromValue = function (from, to, value) {
	    return (value - from) / (to - from);
	};
	exports.getValueFromProgress = function (from, to, progress) {
	    return (-progress * from) + (progress * to) + from;
	};
	exports.pointFromAngleAndDistance = function (origin, angle, distance) {
	    angle = exports.degreesToRadians(angle);
	    return {
	        x: distance * Math.cos(angle) + origin.x,
	        y: distance * Math.sin(angle) + origin.y
	    };
	};
	exports.radiansToDegrees = function (radians) { return radians * 180 / Math.PI; };
	exports.smooth = function (newValue, oldValue, duration, smoothing) {
	    if (smoothing === void 0) { smoothing = 0; }
	    return toDecimal(oldValue + (duration * (newValue - oldValue) / Math.max(smoothing, duration)));
	};
	exports.speedPerFrame = function (xps, frameDuration) {
	    return (isNum(xps)) ? xps / (1000 / frameDuration) : 0;
	};
	exports.speedPerSecond = function (velocity, frameDuration) {
	    return frameDuration ? velocity * (1000 / frameDuration) : 0;
	};
	exports.stepProgress = function (steps, progress) {
	    var segment = 1 / (steps - 1);
	    var target = 1 - (1 / steps);
	    var progressOfTarget = Math.min(progress / target, 1);
	    return Math.floor(progressOfTarget / segment) * segment;
	};
	//# sourceMappingURL=calc.js.map

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var transformers_1 = __webpack_require__(11);
	var Chainable = (function () {
	    function Chainable(props) {
	        if (props === void 0) { props = {}; }
	        this.props = props;
	    }
	    Chainable.prototype.applyMiddleware = function (middleware) {
	        return this.create(__assign({}, this.props, { middleware: this.props.middleware ? [middleware].concat(this.props.middleware) : [middleware] }));
	    };
	    Chainable.prototype.pipe = function () {
	        var funcs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            funcs[_i] = arguments[_i];
	        }
	        var pipedUpdate = funcs.length === 1 ? funcs[0] : transformers_1.pipe.apply(void 0, funcs);
	        return this.applyMiddleware(function (update) { return function (v) { return update(pipedUpdate(v)); }; });
	    };
	    Chainable.prototype.while = function (predicate) {
	        return this.applyMiddleware(function (update, complete) { return function (v) { return predicate(v) ? update(v) : complete(); }; });
	    };
	    Chainable.prototype.filter = function (predicate) {
	        return this.applyMiddleware(function (update, complete) { return function (v) { return predicate(v) && update(v); }; });
	    };
	    return Chainable;
	}());
	exports.default = Chainable;
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var action_1 = __webpack_require__(2);
	var chain = function () {
	    var actions = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        actions[_i] = arguments[_i];
	    }
	    return action_1.default(function (_a) {
	        var update = _a.update, complete = _a.complete;
	        var i = 0;
	        var current;
	        var playCurrent = function () {
	            current = actions[i].start({
	                complete: function () {
	                    i++;
	                    (i >= actions.length) ? complete() : playCurrent();
	                },
	                update: update
	            });
	        };
	        playCurrent();
	        return {
	            stop: function () { return current && current.stop(); }
	        };
	    });
	};
	exports.default = chain;
	//# sourceMappingURL=chain.js.map

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var multi_1 = __webpack_require__(44);
	var composite = multi_1.default({
	    getOutput: function () { return ({}); },
	    getCount: function (subs) { return Object.keys(subs).length; },
	    getFirst: function (subs) { return subs[Object.keys(subs)[0]]; },
	    mapApi: function (subs, methodName) { return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return Object.keys(subs)
	            .reduce(function (output, propKey) {
	            if (subs[propKey][methodName]) {
	                (args[0] && args[0][propKey] !== undefined)
	                    ? output[propKey] = subs[propKey][methodName](args[0][propKey])
	                    : output[propKey] = (_a = subs[propKey])[methodName].apply(_a, args);
	            }
	            return output;
	            var _a;
	        }, {});
	    }; },
	    setProp: function (output, name, v) { return output[name] = v; },
	    startActions: function (actions, starter) { return Object.keys(actions)
	        .reduce(function (subs, key) {
	        subs[key] = starter(actions[key], key);
	        return subs;
	    }, {}); }
	});
	exports.default = composite;
	//# sourceMappingURL=composite.js.map

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var action_1 = __webpack_require__(2);
	var calc_1 = __webpack_require__(3);
	var parallel_1 = __webpack_require__(19);
	var crossfade = function (a, b) { return action_1.default(function (observer) {
	    var balance = 0;
	    var fadable = parallel_1.default(a, b).start(__assign({}, observer, { update: function (_a) {
	            var va = _a[0], vb = _a[1];
	            observer.update(calc_1.getValueFromProgress(va, vb, balance));
	        } }));
	    return {
	        setBalance: function (v) { return balance = v; },
	        stop: function () { return fadable.stop(); }
	    };
	}); };
	exports.default = crossfade;
	//# sourceMappingURL=crossfade.js.map

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var action_1 = __webpack_require__(2);
	var delay = function (timeToDelay) { return action_1.default(function (_a) {
	    var complete = _a.complete;
	    var timeout = setTimeout(complete, timeToDelay);
	    return {
	        stop: function () { return clearTimeout(timeout); }
	    };
	}); };
	exports.default = delay;
	//# sourceMappingURL=delay.js.map

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var action_1 = __webpack_require__(2);
	var merge = function () {
	    var actions = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        actions[_i] = arguments[_i];
	    }
	    return action_1.default(function (observer) {
	        var subs = actions.map(function (thisAction) { return thisAction.start(observer); });
	        return {
	            stop: function () { return subs.forEach(function (sub) { return sub.stop(); }); }
	        };
	    });
	};
	exports.default = merge;
	//# sourceMappingURL=merge.js.map

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var framesync_1 = __webpack_require__(4);
	var action_1 = __webpack_require__(2);
	var multi = function (_a) {
	    var getCount = _a.getCount, getFirst = _a.getFirst, getOutput = _a.getOutput, mapApi = _a.mapApi, setProp = _a.setProp, startActions = _a.startActions;
	    return function (actions) { return action_1.default(function (_a) {
	        var update = _a.update, complete = _a.complete, error = _a.error;
	        var numActions = getCount(actions);
	        var output = getOutput();
	        var updateOutput = function () { return update(output); };
	        var numCompletedActions = 0;
	        var subs = startActions(actions, function (a, name) { return a.start({
	            complete: function () {
	                numCompletedActions++;
	                if (numCompletedActions === numActions)
	                    framesync_1.onFrameUpdate(complete);
	            },
	            error: error,
	            update: function (v) {
	                setProp(output, name, v);
	                framesync_1.onFrameUpdate(updateOutput, true);
	            }
	        }); });
	        return Object.keys(getFirst(subs))
	            .reduce(function (api, methodName) {
	            api[methodName] = mapApi(subs, methodName);
	            return api;
	        }, {});
	    }); };
	};
	exports.default = multi;
	//# sourceMappingURL=multi.js.map

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var multi_1 = __webpack_require__(44);
	var parallel = multi_1.default({
	    getOutput: function () { return ([]); },
	    getCount: function (subs) { return subs.length; },
	    getFirst: function (subs) { return subs[0]; },
	    mapApi: function (subs, methodName) { return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return subs.map(function (sub, i) {
	            if (sub[methodName]) {
	                return Array.isArray(args[0])
	                    ? sub[methodName](args[0][i])
	                    : sub[methodName].apply(sub, args);
	            }
	        });
	    }; },
	    setProp: function (output, name, v) { return output[name] = v; },
	    startActions: function (actions, starter) { return actions.map(function (action, i) { return starter(action, i); }); }
	});
	exports.default = function () {
	    var actions = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        actions[_i] = arguments[_i];
	    }
	    return parallel(actions);
	};
	//# sourceMappingURL=parallel.js.map

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var action_1 = __webpack_require__(2);
	var schedule = function (scheduler, schedulee) { return action_1.default(function (_a) {
	    var update = _a.update, complete = _a.complete;
	    var latest;
	    var schedulerSub = scheduler.start({
	        update: function () { return latest !== undefined && update(latest); },
	        complete: complete
	    });
	    var scheduleeSub = schedulee.start({
	        update: function (v) { return latest = v; },
	        complete: complete
	    });
	    return {
	        stop: function () {
	            schedulerSub.stop();
	            scheduleeSub.stop();
	        }
	    };
	}); };
	exports.default = schedule;
	//# sourceMappingURL=schedule.js.map

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var chain_1 = __webpack_require__(42);
	var delay_1 = __webpack_require__(43);
	var parallel_1 = __webpack_require__(19);
	var stagger = function (actions, interval) {
	    var intervalIsNumber = typeof interval === 'number';
	    var actionsWithDelay = actions.map(function (a, i) {
	        var timeToDelay = intervalIsNumber ? interval * i : interval(i);
	        return chain_1.default(delay_1.default(timeToDelay), a);
	    });
	    return parallel_1.default.apply(void 0, actionsWithDelay);
	};
	exports.default = stagger;
	//# sourceMappingURL=stagger.js.map

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var DEFAULT_OVERSHOOT_STRENGTH = 1.525;
	exports.createReversedEasing = function (easing) {
	    return function (p) { return 1 - easing(1 - p); };
	};
	exports.createMirroredEasing = function (easing) {
	    return function (p) { return (p <= 0.5) ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2; };
	};
	exports.linear = function (p) { return p; };
	exports.createExpoIn = function (power) { return function (p) { return Math.pow(p, power); }; };
	exports.easeIn = exports.createExpoIn(2);
	exports.easeOut = exports.createReversedEasing(exports.easeIn);
	exports.easeInOut = exports.createMirroredEasing(exports.easeIn);
	exports.circIn = function (p) { return 1 - Math.sin(Math.acos(p)); };
	exports.circOut = exports.createReversedEasing(exports.circIn);
	exports.circInOut = exports.createMirroredEasing(exports.circOut);
	exports.createBackIn = function (power) { return function (p) { return (p * p) * ((power + 1) * p - power); }; };
	exports.backIn = exports.createBackIn(DEFAULT_OVERSHOOT_STRENGTH);
	exports.backOut = exports.createReversedEasing(exports.backIn);
	exports.backInOut = exports.createMirroredEasing(exports.backIn);
	exports.createAnticipateEasing = function (power) {
	    var backEasing = exports.createBackIn(power);
	    return function (p) { return ((p *= 2) < 1) ? 0.5 * backEasing(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1))); };
	};
	exports.anticipate = exports.createAnticipateEasing(DEFAULT_OVERSHOOT_STRENGTH);
	var NEWTON_ITERATIONS = 8;
	var NEWTON_MIN_SLOPE = 0.001;
	var SUBDIVISION_PRECISION = 0.0000001;
	var SUBDIVISION_MAX_ITERATIONS = 10;
	var K_SPLINE_TABLE_SIZE = 11;
	var K_SAMPLE_STEP_SIZE = 1.0 / (K_SPLINE_TABLE_SIZE - 1.0);
	var FLOAT_32_SUPPORTED = (typeof Float32Array !== 'undefined');
	var a = function (a1, a2) { return 1.0 - 3.0 * a2 + 3.0 * a1; };
	var b = function (a1, a2) { return 3.0 * a2 - 6.0 * a1; };
	var c = function (a1) { return 3.0 * a1; };
	var getSlope = function (t, a1, a2) { return 3.0 * a(a1, a2) * t * t + 2.0 * b(a1, a2) * t + c(a1); };
	var calcBezier = function (t, a1, a2) { return ((a(a1, a2) * t + b(a1, a2)) * t + c(a1)) * t; };
	function cubicBezier(mX1, mY1, mX2, mY2) {
	    var sampleValues = FLOAT_32_SUPPORTED ? new Float32Array(K_SPLINE_TABLE_SIZE) : new Array(K_SPLINE_TABLE_SIZE);
	    var _precomputed = false;
	    var binarySubdivide = function (aX, aA, aB) {
	        var i = 0;
	        var currentX;
	        var currentT;
	        do {
	            currentT = aA + (aB - aA) / 2.0;
	            currentX = calcBezier(currentT, mX1, mX2) - aX;
	            if (currentX > 0.0) {
	                aB = currentT;
	            }
	            else {
	                aA = currentT;
	            }
	        } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	        return currentT;
	    };
	    var newtonRaphsonIterate = function (aX, aGuessT) {
	        var i = 0;
	        var currentSlope = 0;
	        var currentX;
	        for (; i < NEWTON_ITERATIONS; ++i) {
	            currentSlope = getSlope(aGuessT, mX1, mX2);
	            if (currentSlope === 0.0) {
	                return aGuessT;
	            }
	            currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	            aGuessT -= currentX / currentSlope;
	        }
	        return aGuessT;
	    };
	    var calcSampleValues = function () {
	        for (var i = 0; i < K_SPLINE_TABLE_SIZE; ++i) {
	            sampleValues[i] = calcBezier(i * K_SAMPLE_STEP_SIZE, mX1, mX2);
	        }
	    };
	    var getTForX = function (aX) {
	        var intervalStart = 0.0;
	        var currentSample = 1;
	        var lastSample = K_SPLINE_TABLE_SIZE - 1;
	        var dist = 0.0;
	        var guessForT = 0.0;
	        var initialSlope = 0.0;
	        for (; currentSample != lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
	            intervalStart += K_SAMPLE_STEP_SIZE;
	        }
	        --currentSample;
	        dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
	        guessForT = intervalStart + dist * K_SAMPLE_STEP_SIZE;
	        initialSlope = getSlope(guessForT, mX1, mX2);
	        if (initialSlope >= NEWTON_MIN_SLOPE) {
	            return newtonRaphsonIterate(aX, guessForT);
	        }
	        else if (initialSlope === 0.0) {
	            return guessForT;
	        }
	        else {
	            return binarySubdivide(aX, intervalStart, intervalStart + K_SAMPLE_STEP_SIZE);
	        }
	    };
	    var precompute = function () {
	        _precomputed = true;
	        if (mX1 != mY1 || mX2 != mY2) {
	            calcSampleValues();
	        }
	    };
	    var resolver = function (aX) {
	        var returnValue;
	        if (!_precomputed) {
	            precompute();
	        }
	        if (mX1 === mY1 && mX2 === mY2) {
	            returnValue = aX;
	        }
	        else if (aX === 0) {
	            returnValue = 0;
	        }
	        else if (aX === 1) {
	            returnValue = 1;
	        }
	        else {
	            returnValue = calcBezier(getTForX(aX), mY1, mY2);
	        }
	        return returnValue;
	    };
	    return resolver;
	}
	exports.cubicBezier = cubicBezier;
	;
	//# sourceMappingURL=easing.js.map

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var action_1 = __webpack_require__(2);
	exports.action = action_1.default;
	var multicast_1 = __webpack_require__(98);
	exports.multicast = multicast_1.default;
	var value_1 = __webpack_require__(99);
	exports.value = value_1.default;
	var decay_1 = __webpack_require__(89);
	exports.decay = decay_1.default;
	var every_frame_1 = __webpack_require__(16);
	exports.everyFrame = every_frame_1.default;
	var keyframes_1 = __webpack_require__(38);
	exports.keyframes = keyframes_1.default;
	var physics_1 = __webpack_require__(90);
	exports.physics = physics_1.default;
	var spring_1 = __webpack_require__(91);
	exports.spring = spring_1.default;
	var timeline_1 = __webpack_require__(92);
	exports.timeline = timeline_1.default;
	var tween_1 = __webpack_require__(39);
	exports.tween = tween_1.default;
	var listen_1 = __webpack_require__(29);
	exports.listen = listen_1.default;
	var multitouch_1 = __webpack_require__(45);
	exports.multitouch = multitouch_1.default;
	var pointer_1 = __webpack_require__(97);
	exports.pointer = pointer_1.default;
	var mouse_1 = __webpack_require__(46);
	exports.mouse = mouse_1.default;
	var chain_1 = __webpack_require__(42);
	exports.chain = chain_1.default;
	var composite_1 = __webpack_require__(28);
	exports.composite = composite_1.default;
	var crossfade_1 = __webpack_require__(93);
	exports.crossfade = crossfade_1.default;
	var delay_1 = __webpack_require__(43);
	exports.delay = delay_1.default;
	var merge_1 = __webpack_require__(94);
	exports.merge = merge_1.default;
	var parallel_1 = __webpack_require__(19);
	exports.parallel = parallel_1.default;
	var schedule_1 = __webpack_require__(95);
	exports.schedule = schedule_1.default;
	var stagger_1 = __webpack_require__(96);
	exports.stagger = stagger_1.default;
	var calc = __webpack_require__(3);
	exports.calc = calc;
	var easing = __webpack_require__(10);
	exports.easing = easing;
	var transform = __webpack_require__(11);
	exports.transform = transform;
	var stylefire_1 = __webpack_require__(102);
	exports.styler = stylefire_1.default;
	var css_1 = __webpack_require__(51);
	exports.css = css_1.default;
	var svg_1 = __webpack_require__(55);
	exports.svg = svg_1.default;
	var valueTypes = __webpack_require__(7);
	exports.valueTypes = valueTypes;
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var action_1 = __webpack_require__(2);
	var listen = function (element, events, options) { return action_1.default(function (_a) {
	    var update = _a.update;
	    var eventNames = events.split(' ').map(function (eventName) {
	        element.addEventListener(eventName, update, options);
	        return eventName;
	    });
	    return {
	        stop: function () { return eventNames.forEach(function (eventName) { return element.removeEventListener(eventName, update, options); }); }
	    };
	}); };
	exports.default = listen;
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var framesync_1 = __webpack_require__(4);
	var action_1 = __webpack_require__(2);
	var calc_1 = __webpack_require__(3);
	var listen_1 = __webpack_require__(29);
	var utils_1 = __webpack_require__(47);
	var points = [utils_1.defaultPointerPos()];
	var isTouchDevice = false;
	if (typeof document !== 'undefined') {
	    var updatePointsLocation = function (_a) {
	        var touches = _a.touches;
	        isTouchDevice = true;
	        var numTouches = touches.length;
	        points.length = 0;
	        for (var i = 0; i < numTouches; i++) {
	            var thisTouch = touches[i];
	            points.push(utils_1.eventToPoint(thisTouch));
	        }
	    };
	    listen_1.default(document, 'touchstart touchmove', true)
	        .start(updatePointsLocation);
	}
	var multitouch = function (_a) {
	    var _b = _a === void 0 ? {} : _a, _c = _b.preventDefault, preventDefault = _c === void 0 ? true : _c, _d = _b.scale, scale = _d === void 0 ? 1.0 : _d, _e = _b.rotate, rotate = _e === void 0 ? 0.0 : _e;
	    return action_1.default(function (_a) {
	        var update = _a.update;
	        var output = {
	            touches: points,
	            scale: scale,
	            rotate: rotate
	        };
	        var initialDistance = 0.0;
	        var initialRotation = 0.0;
	        var isGesture = points.length > 1;
	        if (isGesture) {
	            var firstTouch = points[0], secondTouch = points[1];
	            initialDistance = calc_1.distance(firstTouch, secondTouch);
	            initialRotation = calc_1.angle(firstTouch, secondTouch);
	        }
	        var updatePoint = function () {
	            if (isGesture) {
	                var firstTouch = points[0], secondTouch = points[1];
	                var newDistance = calc_1.distance(firstTouch, secondTouch);
	                var newRotation = calc_1.angle(firstTouch, secondTouch);
	                output.scale = scale * (newDistance / initialDistance);
	                output.rotate = rotate + (newRotation - initialRotation);
	            }
	            update(output);
	        };
	        var onMove = function (e) {
	            if (preventDefault || e.touches.length > 1)
	                e.preventDefault();
	            framesync_1.onFrameUpdate(updatePoint);
	        };
	        var updateOnMove = listen_1.default(document, 'touchmove', { passive: !preventDefault })
	            .start(onMove);
	        if (isTouchDevice)
	            framesync_1.onFrameUpdate(updatePoint);
	        return {
	            stop: function () {
	                framesync_1.cancelOnFrameUpdate(updatePoint);
	                updateOnMove.stop();
	            }
	        };
	    });
	};
	exports.default = multitouch;
	exports.getIsTouchDevice = function () { return isTouchDevice; };
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __rest = (this && this.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
	            t[p[i]] = s[p[i]];
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var transformers_1 = __webpack_require__(11);
	var multitouch_1 = __webpack_require__(45);
	var mouse_1 = __webpack_require__(46);
	var getFirstTouch = function (_a) {
	    var firstTouch = _a[0];
	    return firstTouch;
	};
	var pointer = function (props) {
	    if (props === void 0) { props = {}; }
	    return multitouch_1.getIsTouchDevice()
	        ? multitouch_1.default(props).pipe(function (_a) {
	            var touches = _a.touches;
	            return touches;
	        }, getFirstTouch)
	        : mouse_1.default(props);
	};
	exports.default = function (_a) {
	    if (_a === void 0) { _a = {}; }
	    var x = _a.x, y = _a.y, props = __rest(_a, ["x", "y"]);
	    if (x !== undefined || y !== undefined) {
	        var applyXOffset_1 = transformers_1.applyOffset(x || 0);
	        var applyYOffset_1 = transformers_1.applyOffset(y || 0);
	        var delta_1 = { x: 0, y: 0 };
	        return pointer(props).pipe(function (point) {
	            delta_1.x = applyXOffset_1(point.x);
	            delta_1.y = applyYOffset_1(point.y);
	            return delta_1;
	        });
	    }
	    else {
	        return pointer(props);
	    }
	};
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var framesync_1 = __webpack_require__(4);
	var action_1 = __webpack_require__(2);
	var listen_1 = __webpack_require__(29);
	var utils_1 = __webpack_require__(47);
	var point = utils_1.defaultPointerPos();
	var isMouseDevice = false;
	if (typeof document !== 'undefined') {
	    var updatePointLocation = function (e) {
	        isMouseDevice = true;
	        utils_1.eventToPoint(e, point);
	    };
	    listen_1.default(document, 'mousedown mousemove', true)
	        .start(updatePointLocation);
	}
	var mouse = function (_a) {
	    var _b = (_a === void 0 ? {} : _a).preventDefault, preventDefault = _b === void 0 ? true : _b;
	    return action_1.default(function (_a) {
	        var update = _a.update;
	        var updatePoint = function () { return update(point); };
	        var onMove = function (e) {
	            if (preventDefault)
	                e.preventDefault();
	            framesync_1.onFrameUpdate(updatePoint);
	        };
	        var updateOnMove = listen_1.default(document, 'mousemove').start(onMove);
	        if (isMouseDevice)
	            framesync_1.onFrameUpdate(updatePoint);
	        return {
	            stop: function () {
	                framesync_1.cancelOnFrameUpdate(updatePoint);
	                updateOnMove.stop();
	            }
	        };
	    });
	};
	exports.default = mouse;
	//# sourceMappingURL=mouse.js.map

/***/ }),

/***/ 47:
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.defaultPointerPos = function () { return ({
	    clientX: 0,
	    clientY: 0,
	    pageX: 0,
	    pageY: 0,
	    x: 0,
	    y: 0
	}); };
	exports.eventToPoint = function (e, point) {
	    if (point === void 0) { point = exports.defaultPointerPos(); }
	    point.clientX = point.x = e.clientX;
	    point.clientY = point.y = e.clientY;
	    point.pageX = e.pageX;
	    point.pageY = e.pageY;
	    return point;
	};
	//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 48:
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observer = (function () {
	    function Observer(_a, observer) {
	        var middleware = _a.middleware, onComplete = _a.onComplete;
	        var _this = this;
	        this.isActive = true;
	        this.update = function (v) {
	            if (_this.observer.update)
	                _this.updateObserver(v);
	        };
	        this.complete = function () {
	            if (_this.observer.complete && _this.isActive)
	                _this.observer.complete();
	            if (_this.onComplete)
	                _this.onComplete();
	            _this.isActive = false;
	        };
	        this.error = function (err) {
	            if (_this.observer.error && _this.isActive)
	                _this.observer.error(err);
	            _this.isActive = false;
	        };
	        this.observer = observer;
	        this.updateObserver = function (v) { return observer.update(v); };
	        this.onComplete = onComplete;
	        if (observer.update && middleware && middleware.length) {
	            middleware.forEach(function (m) { return _this.updateObserver = m(_this.updateObserver, _this.complete); });
	        }
	    }
	    return Observer;
	}());
	exports.Observer = Observer;
	exports.default = function (observerCandidate, _a, onComplete) {
	    var middleware = _a.middleware;
	    if (typeof observerCandidate === 'function') {
	        return new Observer({ middleware: middleware, onComplete: onComplete }, { update: observerCandidate });
	    }
	    else {
	        return new Observer({ middleware: middleware, onComplete: onComplete }, observerCandidate);
	    }
	};
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var chainable_1 = __webpack_require__(41);
	var observer_1 = __webpack_require__(48);
	var BaseMulticast = (function (_super) {
	    __extends(BaseMulticast, _super);
	    function BaseMulticast() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.subscribers = [];
	        return _this;
	    }
	    BaseMulticast.prototype.complete = function () {
	        this.subscribers.forEach(function (subscriber) { return subscriber.complete(); });
	    };
	    BaseMulticast.prototype.error = function (err) {
	        this.subscribers.forEach(function (subscriber) { return subscriber.error(err); });
	    };
	    BaseMulticast.prototype.update = function (v) {
	        for (var i = 0; i < this.subscribers.length; i++) {
	            this.subscribers[i].update(v);
	        }
	    };
	    BaseMulticast.prototype.subscribe = function (observerCandidate) {
	        var _this = this;
	        var observer = observer_1.default(observerCandidate, this.props);
	        this.subscribers.push(observer);
	        var subscription = {
	            unsubscribe: function () {
	                var index = _this.subscribers.indexOf(observer);
	                if (index !== -1)
	                    _this.subscribers.splice(index, 1);
	            }
	        };
	        return subscription;
	    };
	    BaseMulticast.prototype.stop = function () {
	        if (this.parent)
	            this.parent.stop();
	    };
	    BaseMulticast.prototype.registerParent = function (subscription) {
	        this.stop();
	        this.parent = subscription;
	    };
	    return BaseMulticast;
	}(chainable_1.default));
	exports.BaseMulticast = BaseMulticast;
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var _1 = __webpack_require__(49);
	var Multicast = (function (_super) {
	    __extends(Multicast, _super);
	    function Multicast() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Multicast.prototype.create = function (props) {
	        return new Multicast(props);
	    };
	    return Multicast;
	}(_1.BaseMulticast));
	exports.Multicast = Multicast;
	exports.default = function () { return new Multicast(); };
	//# sourceMappingURL=multicast.js.map

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var framesync_1 = __webpack_require__(4);
	var calc_1 = __webpack_require__(3);
	var _1 = __webpack_require__(49);
	var isValueList = function (v) { return Array.isArray(v); };
	var isSingleValue = function (v) {
	    var typeOfV = typeof v;
	    return (typeOfV === 'string' || typeOfV === 'number');
	};
	var ValueReaction = (function (_super) {
	    __extends(ValueReaction, _super);
	    function ValueReaction(props) {
	        var _this = _super.call(this, props) || this;
	        _this.scheduleVelocityCheck = function () { return framesync_1.onFrameEnd(_this.velocityCheck); };
	        _this.velocityCheck = function () {
	            if (framesync_1.currentFrameTime() !== _this.lastUpdated) {
	                _this.prev = _this.current;
	            }
	        };
	        _this.prev = _this.current = props.value || 0;
	        if (isSingleValue(_this.current)) {
	            _this.updateCurrent = function (v) { return _this.current = v; };
	            _this.getVelocityOfCurrent = function () { return _this.getSingleVelocity(_this.current, _this.prev); };
	        }
	        else if (isValueList(_this.current)) {
	            _this.updateCurrent = function (v) { return _this.current = v.slice(); };
	            _this.getVelocityOfCurrent = function () { return _this.getListVelocity(); };
	        }
	        else {
	            _this.updateCurrent = function (v) {
	                _this.current = {};
	                for (var key in v) {
	                    if (v.hasOwnProperty(key)) {
	                        _this.current[key] = v[key];
	                    }
	                }
	            };
	            _this.getVelocityOfCurrent = function () { return _this.getMapVelocity(); };
	        }
	        if (props.initialSubscription)
	            _this.subscribe(props.initialSubscription);
	        return _this;
	    }
	    ValueReaction.prototype.create = function (props) {
	        return new ValueReaction(props);
	    };
	    ValueReaction.prototype.get = function () {
	        return this.current;
	    };
	    ValueReaction.prototype.getVelocity = function () {
	        return this.getVelocityOfCurrent();
	    };
	    ValueReaction.prototype.update = function (v) {
	        _super.prototype.update.call(this, v);
	        this.prev = this.current;
	        this.updateCurrent(v);
	        this.timeDelta = framesync_1.timeSinceLastFrame();
	        this.lastUpdated = framesync_1.currentFrameTime();
	        framesync_1.onFrameEnd(this.scheduleVelocityCheck);
	    };
	    ValueReaction.prototype.subscribe = function (observerCandidate) {
	        var sub = _super.prototype.subscribe.call(this, observerCandidate);
	        this.update(this.current);
	        return sub;
	    };
	    ValueReaction.prototype.getSingleVelocity = function (current, prev) {
	        return (typeof current === 'number' && typeof prev === 'number')
	            ? calc_1.speedPerSecond(current - prev, this.timeDelta)
	            : calc_1.speedPerSecond(parseFloat(current) - parseFloat(prev), this.timeDelta) || 0;
	    };
	    ValueReaction.prototype.getListVelocity = function () {
	        var _this = this;
	        return this.current.map(function (c, i) { return _this.getSingleVelocity(c, _this.prev[i]); });
	    };
	    ValueReaction.prototype.getMapVelocity = function () {
	        var velocity = {};
	        for (var key in this.current) {
	            if (this.current.hasOwnProperty(key)) {
	                velocity[key] = this.getSingleVelocity(this.current[key], this.prev[key]);
	            }
	        }
	        return velocity;
	    };
	    return ValueReaction;
	}(_1.BaseMulticast));
	exports.ValueReaction = ValueReaction;
	exports.default = function (value, initialSubscription) { return new ValueReaction({ value: value, initialSubscription: initialSubscription }); };
	//# sourceMappingURL=value.js.map

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var framesync_1 = __webpack_require__(4);
	var style_value_types_1 = __webpack_require__(7);
	var calc_1 = __webpack_require__(3);
	var noop = function (v) { return v; };
	exports.appendUnit = function (unit) { return function (v) { return "" + v + unit; }; };
	exports.applyOffset = function (from, to) {
	    var hasReceivedFrom = true;
	    if (to === undefined) {
	        to = from;
	        hasReceivedFrom = false;
	    }
	    var getOffset = function (v) { return v - from; };
	    var applyOffsetTo = function (v) { return v + to; };
	    return function (v) {
	        if (hasReceivedFrom) {
	            return applyOffsetTo(getOffset(v));
	        }
	        else {
	            from = v;
	            hasReceivedFrom = true;
	            return to;
	        }
	    };
	};
	var blend = function (from, to, v) {
	    var fromExpo = from * from;
	    var toExpo = to * to;
	    return Math.sqrt(v * (toExpo - fromExpo) + fromExpo);
	};
	exports.blendColor = function (from, to) {
	    var fromColor = (typeof from === 'string') ? style_value_types_1.color.parse(from) : from;
	    var toColor = (typeof to === 'string') ? style_value_types_1.color.parse(to) : to;
	    var blended = __assign({}, fromColor);
	    var blendFunc = (from.hue !== undefined ||
	        typeof from === 'string' && style_value_types_1.hsla.test(from)) ? calc_1.getValueFromProgress
	        : blend;
	    return function (v) {
	        blended = __assign({}, blended);
	        for (var key in blended) {
	            if (key !== 'alpha' && blended.hasOwnProperty(key)) {
	                blended[key] = blendFunc(fromColor[key], toColor[key], v);
	            }
	        }
	        blended.alpha = calc_1.getValueFromProgress(fromColor.alpha, toColor.alpha, v);
	        return blended;
	    };
	};
	exports.clamp = function (min, max) { return function (v) { return Math.min(Math.max(v, min), max); }; };
	var combineFunctions = function (a, b) { return function (v) { return b(a(v)); }; };
	exports.pipe = function () {
	    var transformers = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        transformers[_i] = arguments[_i];
	    }
	    return transformers.reduce(combineFunctions);
	};
	exports.conditional = function (check, apply) { return function (v) { return check(v) ? apply(v) : v; }; };
	var slowInterpolate = function (input, output, rangeLength, rangeEasing) {
	    var finalIndex = rangeLength - 1;
	    if (input[0] > input[finalIndex]) {
	        input.reverse();
	        output.reverse();
	    }
	    return function (v) {
	        if (v <= input[0]) {
	            return output[0];
	        }
	        if (v >= input[finalIndex]) {
	            return output[finalIndex];
	        }
	        var i = 1;
	        for (; i < rangeLength; i++) {
	            if (input[i] > v || i === finalIndex) {
	                break;
	            }
	        }
	        var progressInRange = calc_1.getProgressFromValue(input[i - 1], input[i], v);
	        var easedProgress = (rangeEasing) ? rangeEasing[i - 1](progressInRange) : progressInRange;
	        return calc_1.getValueFromProgress(output[i - 1], output[i], easedProgress);
	    };
	};
	var fastInterpolate = function (minA, maxA, minB, maxB) { return function (v) {
	    return (((v - minA) * (maxB - minB)) / (maxA - minA)) + minB;
	}; };
	exports.interpolate = function (input, output, rangeEasing) {
	    var rangeLength = input.length;
	    return rangeLength !== 2
	        ? slowInterpolate(input, output, rangeLength, rangeEasing)
	        : fastInterpolate(input[0], input[1], output[0], output[1]);
	};
	exports.generateStaticSpring = function (alterDisplacement) {
	    if (alterDisplacement === void 0) { alterDisplacement = noop; }
	    return function (constant, origin) { return function (v) {
	        var displacement = origin - v;
	        var springModifiedDisplacement = -constant * (0 - alterDisplacement(Math.abs(displacement)));
	        return (displacement <= 0) ? origin + springModifiedDisplacement : origin - springModifiedDisplacement;
	    }; };
	};
	exports.linearSpring = exports.generateStaticSpring();
	exports.nonlinearSpring = exports.generateStaticSpring(Math.sqrt);
	exports.wrap = function (min, max) { return function (v) {
	    var rangeSize = max - min;
	    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
	}; };
	exports.smooth = function (strength) {
	    if (strength === void 0) { strength = 50; }
	    var previousValue = 0;
	    var lastUpdated = 0;
	    return function (v) {
	        var currentFramestamp = framesync_1.currentFrameTime();
	        var timeDelta = (currentFramestamp !== lastUpdated) ? currentFramestamp - lastUpdated : 0;
	        var newValue = timeDelta ? calc_1.smooth(v, previousValue, timeDelta, strength) : previousValue;
	        lastUpdated = currentFramestamp;
	        previousValue = newValue;
	        return newValue;
	    };
	};
	exports.snap = function (points) {
	    if (typeof points === 'number') {
	        return function (v) { return Math.round(v / points) * points; };
	    }
	    else {
	        var i_1 = 0;
	        var numPoints_1 = points.length;
	        return function (v) {
	            var lastDistance = Math.abs(points[0] - v);
	            for (i_1 = 1; i_1 < numPoints_1; i_1++) {
	                var point = points[i_1];
	                var distance = Math.abs(point - v);
	                if (distance === 0)
	                    return point;
	                if (distance > lastDistance)
	                    return points[i_1 - 1];
	                if (i_1 === numPoints_1 - 1)
	                    return point;
	                lastDistance = distance;
	            }
	        };
	    }
	};
	exports.steps = function (st, min, max) {
	    if (min === void 0) { min = 0; }
	    if (max === void 0) { max = 1; }
	    return function (v) {
	        var progress = calc_1.getProgressFromValue(min, max, v);
	        return calc_1.getValueFromProgress(min, max, calc_1.stepProgress(st, progress));
	    };
	};
	exports.transformMap = function (childTransformers) { return function (v) {
	    var output = __assign({}, v);
	    for (var key in childTransformers) {
	        if (childTransformers.hasOwnProperty(key)) {
	            var childTransformer = childTransformers[key];
	            output[key] = childTransformer(v[key]);
	        }
	    }
	    return output;
	}; };
	//# sourceMappingURL=transformers.js.map

/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var tslib_1 = __webpack_require__(301);
	var heyListen = __webpack_require__(169);
	
	var getPoseValues = function (_a) {
	    var transition = _a.transition, delay = _a.delay, delayChildren = _a.delayChildren, staggerChildren = _a.staggerChildren, staggerDirection = _a.staggerDirection, afterChildren = _a.afterChildren, beforeChildren = _a.beforeChildren, preTransition = _a.preTransition, applyAtStart = _a.applyAtStart, applyAtEnd = _a.applyAtEnd, props = tslib_1.__rest(_a, ["transition", "delay", "delayChildren", "staggerChildren", "staggerDirection", "afterChildren", "beforeChildren", "preTransition", "applyAtStart", "applyAtEnd"]);
	    return props;
	};
	var selectPoses = function (_a) {
	    var label = _a.label, props = _a.props, values = _a.values, parentValues = _a.parentValues, ancestorValues = _a.ancestorValues, onChange = _a.onChange, passive = _a.passive, initialPose = _a.initialPose, poses = tslib_1.__rest(_a, ["label", "props", "values", "parentValues", "ancestorValues", "onChange", "passive", "initialPose"]);
	    return poses;
	};
	var selectAllValues = function (values, selectValue) {
	    var allValues = {};
	    values.forEach(function (value, key) { return (allValues[key] = selectValue(value)); });
	    return allValues;
	};
	
	var resolveProp = function (target, props) {
	    return typeof target === 'function' ? target(props) : target;
	};
	var poseDefault = function (pose, prop, defaultValue, resolveProps) {
	    return pose && pose[prop] !== undefined
	        ? resolveProp(pose[prop], resolveProps)
	        : defaultValue;
	};
	var startChildAnimations = function (children, next, pose, props) {
	    var animations = [];
	    var delay = poseDefault(pose, 'delayChildren', 0, props);
	    var stagger = poseDefault(pose, 'staggerChildren', 0, props);
	    var staggerDirection = poseDefault(pose, 'staggerDirection', 1, props);
	    var maxStaggerDuration = (children.size - 1) * stagger;
	    var generateStaggerDuration = staggerDirection === 1
	        ? function (i) { return i * stagger; }
	        : function (i) { return maxStaggerDuration - i * stagger; };
	    Array.from(children).forEach(function (child, i) {
	        animations.push(child.set(next, tslib_1.__assign({}, props, { delay: delay + generateStaggerDuration(i) })));
	    });
	    return animations;
	};
	var resolveTransition = function (transition, key, value, props, convertTransitionDefinition, getInstantTransition) {
	    var resolvedTransition;
	    if (typeof transition === 'function') {
	        resolvedTransition = transition(props);
	    }
	    else if (transition[key] || transition.default) {
	        var keyTransition = transition[key] || transition.default;
	        if (typeof keyTransition === 'function') {
	            resolvedTransition = keyTransition(props);
	        }
	        else {
	            resolvedTransition = keyTransition;
	        }
	    }
	    else {
	        resolvedTransition = transition;
	    }
	    return resolvedTransition === false
	        ? getInstantTransition(value, props)
	        : convertTransitionDefinition(value, resolvedTransition, props);
	};
	var findInsertionIndex = function (poseList, priorityList, priorityIndex) {
	    var insertionIndex = 0;
	    for (var i = priorityIndex - 1; i >= 0; i--) {
	        var nextHighestPriorityIndex = poseList.indexOf(priorityList[i]);
	        if (nextHighestPriorityIndex !== -1) {
	            insertionIndex = nextHighestPriorityIndex + 1;
	            break;
	        }
	    }
	    return insertionIndex;
	};
	var applyValues = function (toApply, values, props, setValue, setValueNative) {
	    heyListen.invariant(typeof toApply === 'object', 'applyAtStart and applyAtEnd must be of type object');
	    return Object.keys(toApply).forEach(function (key) {
	        var valueToSet = resolveProp(toApply[key], props);
	        values.has(key)
	            ? setValue(values.get(key), valueToSet)
	            : setValueNative(key, valueToSet, props);
	    });
	};
	var createPoseSetter = function (setterProps) {
	    var state = setterProps.state, poses = setterProps.poses, startAction = setterProps.startAction, stopAction = setterProps.stopAction, getInstantTransition = setterProps.getInstantTransition, addActionDelay = setterProps.addActionDelay, getTransitionProps = setterProps.getTransitionProps, resolveTarget = setterProps.resolveTarget, transformPose = setterProps.transformPose, posePriority = setterProps.posePriority, convertTransitionDefinition = setterProps.convertTransitionDefinition, setValue = setterProps.setValue, setValueNative = setterProps.setValueNative;
	    return function (next, nextProps, propagate) {
	        if (nextProps === void 0) { nextProps = {}; }
	        if (propagate === void 0) { propagate = true; }
	        var children = state.children, values = state.values, props = state.props, activeActions = state.activeActions, activePoses = state.activePoses;
	        var _a = nextProps.delay, delay = _a === void 0 ? 0 : _a;
	        var hasChildren = children.size;
	        var baseTransitionProps = tslib_1.__assign({}, props, nextProps);
	        var nextPose = poses[next];
	        var getChildAnimations = function () {
	            return hasChildren && propagate
	                ? startChildAnimations(children, next, nextPose, baseTransitionProps)
	                : [];
	        };
	        var getParentAnimations = function () {
	            if (!nextPose)
	                return [];
	            if (transformPose)
	                nextPose = transformPose(nextPose, next, state);
	            var preTransition = nextPose.preTransition, getTransition = nextPose.transition, applyAtStart = nextPose.applyAtStart, applyAtEnd = nextPose.applyAtEnd;
	            if (preTransition)
	                preTransition(baseTransitionProps);
	            if (applyAtStart) {
	                applyValues(applyAtStart, values, baseTransitionProps, setValue, setValueNative);
	            }
	            var animations = Object.keys(getPoseValues(nextPose)).map(function (key) {
	                var valuePoses = activePoses.has(key)
	                    ? activePoses.get(key)
	                    : (activePoses.set(key, []), activePoses.get(key));
	                var existingIndex = valuePoses.indexOf(next);
	                if (existingIndex !== -1)
	                    valuePoses.splice(existingIndex, 1);
	                var priority = posePriority ? posePriority.indexOf(next) : 0;
	                var insertionIndex = priority <= 0
	                    ? 0
	                    : findInsertionIndex(valuePoses, posePriority, priority);
	                valuePoses.splice(insertionIndex, 0, next);
	                return insertionIndex === 0
	                    ? new Promise(function (complete) {
	                        var value = values.get(key);
	                        var transitionProps = tslib_1.__assign({}, baseTransitionProps, { key: key,
	                            value: value });
	                        var target = resolveTarget(value, resolveProp(nextPose[key], transitionProps));
	                        if (activeActions.has(key))
	                            stopAction(activeActions.get(key));
	                        var resolveTransitionProps = tslib_1.__assign({ to: target }, transitionProps, getTransitionProps(value, target, transitionProps));
	                        var transition = resolveTransition(getTransition, key, value, resolveTransitionProps, convertTransitionDefinition, getInstantTransition);
	                        var poseDelay = resolveProp(nextPose.delay, transitionProps);
	                        if (delay || poseDelay) {
	                            transition = addActionDelay(delay || poseDelay, transition);
	                        }
	                        activeActions.set(key, startAction(value, transition, complete));
	                    })
	                    : Promise.resolve();
	            });
	            return applyAtEnd
	                ? [
	                    Promise.all(animations).then(function () {
	                        applyValues(applyAtEnd, values, baseTransitionProps, setValue, setValueNative);
	                    })
	                ]
	                : animations;
	        };
	        if (nextPose && hasChildren) {
	            if (resolveProp(nextPose.beforeChildren, baseTransitionProps)) {
	                return Promise.all(getParentAnimations()).then(function () {
	                    return Promise.all(getChildAnimations());
	                });
	            }
	            else if (resolveProp(nextPose.afterChildren, baseTransitionProps)) {
	                return Promise.all(getChildAnimations()).then(function () {
	                    return Promise.all(getParentAnimations());
	                });
	            }
	        }
	        return Promise.all(getParentAnimations().concat(getChildAnimations()));
	    };
	};
	
	var DEFAULT_INITIAL_POSE = 'init';
	var isScale = function (key) { return key.includes('scale'); };
	var defaultReadValueFromSource = function (key) { return (isScale(key) ? 1 : 0); };
	var getInitialValue = function (poses, key, initialPose, props, readValueFromSource, activePoses) {
	    if (readValueFromSource === void 0) { readValueFromSource = defaultReadValueFromSource; }
	    var posesToSearch = Array.isArray(initialPose)
	        ? initialPose
	        : [initialPose];
	    posesToSearch.push(DEFAULT_INITIAL_POSE);
	    var pose = posesToSearch
	        .filter(Boolean)
	        .find(function (name) { return poses[name] && poses[name][key] !== undefined; });
	    activePoses.set(key, [pose || DEFAULT_INITIAL_POSE]);
	    return pose
	        ? resolveProp(poses[pose][key], props)
	        : readValueFromSource(key, props);
	};
	var createValues = function (values, _a) {
	    var userSetValues = _a.userSetValues, createValue = _a.createValue, convertValue = _a.convertValue, readValueFromSource = _a.readValueFromSource, initialPose = _a.initialPose, poses = _a.poses, activePoses = _a.activePoses, props = _a.props;
	    return function (key) {
	        if (values.has(key))
	            return;
	        var value;
	        if (userSetValues && userSetValues[key] !== undefined) {
	            value = convertValue(userSetValues[key], key, props);
	        }
	        else {
	            var initValue = getInitialValue(poses, key, initialPose, props, readValueFromSource, activePoses);
	            value = createValue(initValue, key, props);
	        }
	        values.set(key, value);
	    };
	};
	var scrapeValuesFromPose = function (values, props) { return function (key) {
	    var pose = props.poses[key];
	    Object.keys(getPoseValues(pose)).forEach(createValues(values, props));
	}; };
	var getAncestorValue = function (key, fromParent, ancestors) {
	    if (fromParent === true) {
	        return ancestors[0] && ancestors[0].values.get(key);
	    }
	    else {
	        var foundAncestor = ancestors.find(function (_a) {
	            var label = _a.label;
	            return label === fromParent;
	        });
	        return foundAncestor && foundAncestor.values.get(key);
	    }
	};
	var bindPassiveValues = function (values, _a) {
	    var passive = _a.passive, ancestorValues = _a.ancestorValues, createValue = _a.createValue, readValue = _a.readValue, props = _a.props;
	    return function (key) {
	        var _a = passive[key], valueKey = _a[0], passiveProps = _a[1], fromParent = _a[2];
	        var valueToBind = fromParent && ancestorValues.length
	            ? getAncestorValue(valueKey, fromParent, ancestorValues)
	            : values.has(valueKey) ? values.get(valueKey) : false;
	        if (!valueToBind)
	            return;
	        var newValue = createValue(readValue(valueToBind), key, props, {
	            passiveParentKey: valueKey,
	            passiveParent: valueToBind,
	            passiveProps: passiveProps
	        });
	        values.set(key, newValue);
	    };
	};
	var createValueMap = function (props) {
	    var poses = props.poses, passive = props.passive;
	    var values = new Map();
	    Object.keys(poses).forEach(scrapeValuesFromPose(values, props));
	    if (passive)
	        Object.keys(passive).forEach(bindPassiveValues(values, props));
	    return values;
	};
	
	var applyDefaultTransition = function (pose, key, defaultTransitions) {
	    return tslib_1.__assign({}, pose, { transition: defaultTransitions.has(key)
	            ? defaultTransitions.get(key)
	            : defaultTransitions.get('default') });
	};
	var generateTransitions = function (poses, defaultTransitions) {
	    Object.keys(poses).forEach(function (key) {
	        var pose = poses[key];
	        heyListen.invariant(typeof pose === 'object', "Pose '" + key + "' is of invalid type. All poses should be objects.");
	        poses[key] =
	            pose.transition !== undefined
	                ? pose
	                : applyDefaultTransition(pose, key, defaultTransitions);
	    });
	    return poses;
	};
	
	var sortByReversePriority = function (priorityOrder) { return function (a, b) {
	    var aP = priorityOrder.indexOf(a);
	    var bP = priorityOrder.indexOf(b);
	    if (aP === -1 && bP !== -1)
	        return -1;
	    if (aP !== -1 && bP === -1)
	        return 1;
	    return aP - bP;
	}; };
	
	var poseFactory = function (_a) {
	    var getDefaultProps = _a.getDefaultProps, defaultTransitions = _a.defaultTransitions, bindOnChange = _a.bindOnChange, startAction = _a.startAction, stopAction = _a.stopAction, readValue = _a.readValue, readValueFromSource = _a.readValueFromSource, resolveTarget = _a.resolveTarget, setValue = _a.setValue, setValueNative = _a.setValueNative, createValue = _a.createValue, convertValue = _a.convertValue, getInstantTransition = _a.getInstantTransition, getTransitionProps = _a.getTransitionProps, addActionDelay = _a.addActionDelay, selectValueToRead = _a.selectValueToRead, convertTransitionDefinition = _a.convertTransitionDefinition, transformPose = _a.transformPose, posePriority = _a.posePriority, extendAPI = _a.extendAPI;
	    return function (config) {
	        var parentValues = config.parentValues, _a = config.ancestorValues, ancestorValues = _a === void 0 ? [] : _a;
	        if (parentValues)
	            ancestorValues.unshift({ values: parentValues });
	        var activeActions = new Map();
	        var activePoses = new Map();
	        var children = new Set();
	        var poses = generateTransitions(selectPoses(config), defaultTransitions);
	        var props = config.props || {};
	        if (getDefaultProps)
	            props = tslib_1.__assign({}, props, getDefaultProps(config));
	        var passive = config.passive, userSetValues = config.values, _b = config.initialPose, initialPose = _b === void 0 ? DEFAULT_INITIAL_POSE : _b;
	        var values = createValueMap({
	            poses: poses,
	            passive: passive,
	            ancestorValues: ancestorValues,
	            readValue: readValue,
	            createValue: createValue,
	            convertValue: convertValue,
	            readValueFromSource: readValueFromSource,
	            userSetValues: userSetValues,
	            initialPose: initialPose,
	            activePoses: activePoses,
	            props: props
	        });
	        var state = {
	            activeActions: activeActions,
	            activePoses: activePoses,
	            children: children,
	            props: props,
	            values: values
	        };
	        var onChange = config.onChange;
	        if (onChange)
	            Object.keys(onChange).forEach(bindOnChange(values, onChange));
	        var set = createPoseSetter({
	            state: state,
	            poses: poses,
	            getInstantTransition: getInstantTransition,
	            getTransitionProps: getTransitionProps,
	            convertTransitionDefinition: convertTransitionDefinition,
	            setValue: setValue,
	            setValueNative: setValueNative,
	            startAction: startAction,
	            stopAction: stopAction,
	            resolveTarget: resolveTarget,
	            addActionDelay: addActionDelay,
	            transformPose: transformPose,
	            posePriority: posePriority
	        });
	        var has = function (poseName) { return !!poses[poseName]; };
	        var api = {
	            set: set,
	            unset: function (poseName, poseProps) {
	                var posesToSet = [];
	                activePoses.forEach(function (valuePoses) {
	                    var poseIndex = valuePoses.indexOf(poseName);
	                    if (poseIndex === -1)
	                        return;
	                    var currentPose = valuePoses[0];
	                    valuePoses.splice(poseIndex, 1);
	                    var nextPose = valuePoses[0];
	                    if (nextPose === currentPose)
	                        return;
	                    if (posesToSet.indexOf(nextPose) === -1) {
	                        posesToSet.push(nextPose);
	                    }
	                });
	                var animationsToResolve = posesToSet
	                    .sort(sortByReversePriority(posePriority))
	                    .map(function (poseToSet) { return set(poseToSet, poseProps, false); });
	                children.forEach(function (child) {
	                    return animationsToResolve.push(child.unset(poseName));
	                });
	                return Promise.all(animationsToResolve);
	            },
	            get: function (valueName) {
	                return valueName
	                    ? selectValueToRead(values.get(valueName))
	                    : selectAllValues(values, selectValueToRead);
	            },
	            has: has,
	            setProps: function (newProps) { return (state.props = tslib_1.__assign({}, state.props, newProps)); },
	            _addChild: function (childConfig, factory) {
	                var child = factory(tslib_1.__assign({ initialPose: initialPose }, childConfig, { ancestorValues: [{ label: config.label, values: values }].concat(ancestorValues) }));
	                children.add(child);
	                return child;
	            },
	            removeChild: function (child) { return children.delete(child); },
	            clearChildren: function () {
	                children.forEach(function (child) { return child.destroy(); });
	                children.clear();
	            },
	            destroy: function () {
	                activeActions.forEach(stopAction);
	                children.forEach(function (child) { return child.destroy(); });
	            }
	        };
	        return extendAPI(api, state, config);
	    };
	};
	
	exports.default = poseFactory;


/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var tslib_1 = __webpack_require__(301);
	var React = __webpack_require__(1);
	var poseFactory = _interopDefault(__webpack_require__(613));
	var isValidProp = _interopDefault(__webpack_require__(304));
	var heyListen = __webpack_require__(169);
	
	var hasChanged = function (prev, next) {
	    if (prev === next)
	        return false;
	    var prevIsArray = Array.isArray(prev);
	    var nextIsArray = Array.isArray(next);
	    if (prevIsArray !== nextIsArray || (!prevIsArray && !nextIsArray)) {
	        return true;
	    }
	    else if (prevIsArray && nextIsArray) {
	        var numPrev = prev.length;
	        var numNext = next.length;
	        if (numPrev !== numNext)
	            return true;
	        for (var i = numPrev; i < numPrev; i++) {
	            if (prev[i] !== next[i])
	                return true;
	        }
	    }
	    return false;
	};
	
	var pickAssign = function (shouldPick, sources) {
	    return sources.reduce(function (picked, source) {
	        for (var key in source) {
	            if (shouldPick(key)) {
	                picked[key] = source[key];
	            }
	        }
	        return picked;
	    }, {});
	};
	
	var PoseParentContext = React.createContext({});
	var calcPopFromFlowStyle = function (el) {
	    var offsetTop = el.offsetTop, offsetLeft = el.offsetLeft, offsetWidth = el.offsetWidth, offsetHeight = el.offsetHeight;
	    return {
	        position: 'absolute',
	        top: offsetTop,
	        left: offsetLeft,
	        width: offsetWidth,
	        height: offsetHeight
	    };
	};
	var hasPose = function (pose, key) {
	    return Array.isArray(pose) ? pose.indexOf(key) !== -1 : pose === key;
	};
	var objectToMap = function (obj) {
	    return Object.keys(obj).reduce(function (map, key) {
	        map.set(key, { raw: obj[key] });
	        return map;
	    }, new Map());
	};
	var testAlwaysTrue = function () { return true; };
	var PoseElement = (function (_super) {
	    tslib_1.__extends(PoseElement, _super);
	    function PoseElement(props) {
	        var _this = _super.call(this, props) || this;
	        _this.children = new Set();
	        _this.childrenHandlers = {
	            registerChild: function (props) {
	                _this.children.add(props);
	                if (_this.poser)
	                    _this.flushChildren();
	            },
	            onUnmount: function (child) { return _this.poser.removeChild(child); },
	            getParentPoseConfig: function () { return _this.props.poseConfig; },
	            getInitialPoseFromParent: function () { return _this.getInitialPose(); }
	        };
	        _this.getRefs = function () {
	            var refs = {};
	            var elementType = _this.props.elementType;
	            if (typeof elementType === 'string') {
	                refs.ref = _this.setRef;
	            }
	            else {
	                refs.innerRef = _this.setRef;
	                refs.hostRef = _this.setRef;
	            }
	            return refs;
	        };
	        _this.setRef = function (ref) {
	            if (ref instanceof Element || (_this.ref && ref === null)) {
	                var innerRef = _this.props.innerRef;
	                if (innerRef) {
	                    if (typeof innerRef === 'function') {
	                        innerRef(ref);
	                    }
	                    else {
	                        innerRef.current = ref;
	                    }
	                }
	                _this.ref = ref;
	            }
	        };
	        _this.shouldForwardProp =
	            typeof _this.props.elementType === 'string' ? isValidProp : testAlwaysTrue;
	        return _this;
	    }
	    PoseElement.prototype.getInitialPose = function () {
	        var _a = this.props, getInitialPoseFromParent = _a.getInitialPoseFromParent, pose = _a.pose, _pose = _a._pose, initialPose = _a.initialPose;
	        if (initialPose) {
	            return initialPose;
	        }
	        else {
	            var parentPose = getInitialPoseFromParent && getInitialPoseFromParent();
	            var thisPose = Array.isArray(pose) ? pose : [pose];
	            var thisInternalPose = Array.isArray(_pose) ? _pose : [_pose];
	            var initialPoses = Array.isArray(parentPose)
	                ? parentPose.concat(thisPose, thisInternalPose) : [parentPose].concat(thisPose, thisInternalPose);
	            var filteredInitialPoses = initialPoses.filter(Boolean);
	            return filteredInitialPoses.length ? filteredInitialPoses : undefined;
	        }
	    };
	    PoseElement.prototype.getFirstPose = function () {
	        var _a = this.props, initialPose = _a.initialPose, pose = _a.pose, _pose = _a._pose;
	        if (!initialPose)
	            return;
	        var thisPose = Array.isArray(pose) ? pose : [pose];
	        var thisInternalPose = Array.isArray(_pose) ? _pose : [_pose];
	        return thisPose.concat(thisInternalPose);
	    };
	    PoseElement.prototype.getSetProps = function () {
	        var _a = this.props, elementType = _a.elementType, poseConfig = _a.poseConfig, onValueChange = _a.onValueChange, innerRef = _a.innerRef, _pose = _a._pose, pose = _a.pose, initialPose = _a.initialPose, poseKey = _a.poseKey, onPoseComplete = _a.onPoseComplete, getParentPoseConfig = _a.getParentPoseConfig, registerChild = _a.registerChild, onUnmount = _a.onUnmount, getInitialPoseFromParent = _a.getInitialPoseFromParent, popFromFlow = _a.popFromFlow, values = _a.values, parentValues = _a.parentValues, onDragStart = _a.onDragStart, onDragEnd = _a.onDragEnd, onPressStart = _a.onPressStart, onPressEnd = _a.onPressEnd, props = tslib_1.__rest(_a, ["elementType", "poseConfig", "onValueChange", "innerRef", "_pose", "pose", "initialPose", "poseKey", "onPoseComplete", "getParentPoseConfig", "registerChild", "onUnmount", "getInitialPoseFromParent", "popFromFlow", "values", "parentValues", "onDragStart", "onDragEnd", "onPressStart", "onPressEnd"]);
	        if (popFromFlow && this.ref && this.ref instanceof HTMLElement) {
	            if (!this.popStyle) {
	                props.style = tslib_1.__assign({}, props.style, calcPopFromFlowStyle(this.ref));
	                this.popStyle = props.style;
	            }
	            else {
	                props.style = this.popStyle;
	            }
	        }
	        else {
	            this.popStyle = null;
	        }
	        return props;
	    };
	    PoseElement.prototype.componentDidMount = function () {
	        var _this = this;
	        heyListen.invariant(typeof this.ref !== 'undefined', "No DOM ref found. If you're converting an existing component via posed(Component), you must ensure you're passing the hostRef prop to your underlying DOM element.");
	        var _a = this.props, poseConfig = _a.poseConfig, onValueChange = _a.onValueChange, registerChild = _a.registerChild, values = _a.values, parentValues = _a.parentValues, onDragStart = _a.onDragStart, onDragEnd = _a.onDragEnd, onPressStart = _a.onPressStart, onPressEnd = _a.onPressEnd;
	        var config = tslib_1.__assign({}, poseConfig, { initialPose: this.getInitialPose(), values: values || poseConfig.values, parentValues: parentValues ? objectToMap(parentValues) : undefined, props: this.getSetProps(), onDragStart: onDragStart,
	            onDragEnd: onDragEnd,
	            onPressStart: onPressStart,
	            onPressEnd: onPressEnd, onChange: onValueChange });
	        if (!registerChild) {
	            this.initPoser(poseFactory(this.ref, config));
	        }
	        else {
	            registerChild({
	                element: this.ref,
	                poseConfig: config,
	                onRegistered: function (poser) { return _this.initPoser(poser); }
	            });
	        }
	    };
	    PoseElement.prototype.UNSAFE_componentWillUpdate = function (_a) {
	        var pose = _a.pose, _pose = _a._pose;
	        if (hasPose(pose, 'flip') || hasPose(_pose, 'flip'))
	            this.poser.measure();
	    };
	    PoseElement.prototype.componentDidUpdate = function (prevProps) {
	        var _a = this.props, pose = _a.pose, _pose = _a._pose, poseKey = _a.poseKey;
	        this.poser.setProps(this.getSetProps());
	        if (poseKey !== prevProps.poseKey ||
	            hasChanged(prevProps.pose, pose) ||
	            pose === 'flip') {
	            this.setPose(pose);
	        }
	        if (_pose !== prevProps._pose || _pose === 'flip')
	            this.setPose(_pose);
	    };
	    PoseElement.prototype.componentWillUnmount = function () {
	        if (!this.poser)
	            return;
	        var onUnmount = this.props.onUnmount;
	        if (onUnmount)
	            onUnmount(this.poser);
	        this.poser.destroy();
	    };
	    PoseElement.prototype.initPoser = function (poser) {
	        this.poser = poser;
	        this.flushChildren();
	        var firstPose = this.getFirstPose();
	        if (firstPose)
	            this.setPose(firstPose);
	    };
	    PoseElement.prototype.setPose = function (pose) {
	        var _this = this;
	        var onPoseComplete = this.props.onPoseComplete;
	        var poseList = Array.isArray(pose) ? pose : [pose];
	        Promise.all(poseList.map(function (key) { return key && _this.poser.set(key); })).then(function () { return onPoseComplete && onPoseComplete(); });
	    };
	    PoseElement.prototype.flushChildren = function () {
	        var _this = this;
	        this.children.forEach(function (_a) {
	            var element = _a.element, poseConfig = _a.poseConfig, onRegistered = _a.onRegistered;
	            return onRegistered(_this.poser.addChild(element, poseConfig));
	        });
	        this.children.clear();
	    };
	    PoseElement.prototype.render = function () {
	        var elementType = this.props.elementType;
	        return (React.createElement(PoseParentContext.Provider, { value: this.childrenHandlers }, React.createElement(elementType, pickAssign(this.shouldForwardProp, [
	            this.getSetProps(),
	            this.getRefs()
	        ]))));
	    };
	    return PoseElement;
	}(React.PureComponent));
	
	var supportedElements = [
	    'a',
	    'article',
	    'aside',
	    'audio',
	    'b',
	    'blockquote',
	    'body',
	    'br',
	    'button',
	    'canvas',
	    'caption',
	    'cite',
	    'code',
	    'col',
	    'colgroup',
	    'data',
	    'datalist',
	    'dialog',
	    'div',
	    'em',
	    'embed',
	    'fieldset',
	    'figcaption',
	    'figure',
	    'footer',
	    'form',
	    'h1',
	    'h2',
	    'h3',
	    'h4',
	    'h5',
	    'h6',
	    'head',
	    'header',
	    'hgroup',
	    'hr',
	    'i',
	    'iframe',
	    'img',
	    'input',
	    'label',
	    'legend',
	    'li',
	    'nav',
	    'object',
	    'ol',
	    'option',
	    'p',
	    'param',
	    'picture',
	    'pre',
	    'progress',
	    'q',
	    'section',
	    'select',
	    'span',
	    'strong',
	    'table',
	    'tbody',
	    'td',
	    'textarea',
	    'tfoot',
	    'th',
	    'thead',
	    'time',
	    'title',
	    'tr',
	    'ul',
	    'video',
	    'circle',
	    'clipPath',
	    'defs',
	    'ellipse',
	    'g',
	    'image',
	    'line',
	    'linearGradient',
	    'mask',
	    'path',
	    'pattern',
	    'polygon',
	    'polyline',
	    'radialGradient',
	    'rect',
	    'stop',
	    'svg',
	    'text',
	    'tspan'
	];
	
	var componentCache = new Map();
	var createComponentFactory = function (key) {
	    var componentFactory = function (poseConfig) {
	        if (poseConfig === void 0) { poseConfig = {}; }
	        var config;
	        return function (_a) {
	            var _b = _a.withParent, withParent = _b === void 0 ? true : _b, props = tslib_1.__rest(_a, ["withParent"]);
	            config =
	                config ||
	                    (typeof poseConfig === 'function' ? poseConfig(props) : poseConfig);
	            return !withParent || props.parentValues ? (React.createElement(PoseElement, tslib_1.__assign({ poseConfig: config, elementType: key }, props))) : (React.createElement(PoseParentContext.Consumer, null, function (parentCtx) { return (React.createElement(PoseElement, tslib_1.__assign({ poseConfig: config, elementType: key }, props, parentCtx))); }));
	        };
	    };
	    componentCache.set(key, componentFactory);
	    return componentFactory;
	};
	var getComponentFactory = function (key) {
	    return componentCache.has(key)
	        ? componentCache.get(key)
	        : createComponentFactory(key);
	};
	var posed = (function (component) {
	    return getComponentFactory(component);
	});
	supportedElements.reduce(function (acc, key) {
	    acc[key] = getComponentFactory(key);
	    return acc;
	}, posed);
	
	var Children = React.Children, cloneElement = React.cloneElement;
	var filterChildProps = function (_a) {
	    var children = _a.children, _pose = _a._pose, onPoseComplete = _a.onPoseComplete, popFromFlow = _a.popFromFlow, props = tslib_1.__rest(_a, ["children", "_pose", "onPoseComplete", "popFromFlow"]);
	    return props;
	};
	var getKey = function (child) {
	    heyListen.invariant(child && child.key !== null, 'Every child of Transition must be given a unique key');
	    var childKey = typeof child.key === 'number' ? child.key.toString() : child.key;
	    return childKey.replace('.$', '');
	};
	var handleTransition = function (_a, _b) {
	    var displayedChildren = _b.children, finishedLeaving = _b.finishedLeaving, scheduleChildRemoval = _b.scheduleChildRemoval, hasMounted = _b.hasMounted;
	    var targetChildren = _a.children, preEnterPose = _a.preEnterPose, enterPose = _a.enterPose, exitPose = _a.exitPose, animateOnMount = _a.animateOnMount, enterAfterExit = _a.enterAfterExit, flipMove = _a.flipMove, onRest = _a.onRest, propsForChild = tslib_1.__rest(_a, ["children", "preEnterPose", "enterPose", "exitPose", "animateOnMount", "enterAfterExit", "flipMove", "onRest"]);
	    targetChildren = makeChildList(targetChildren);
	    var children = [];
	    var prevKeys = displayedChildren.map(getKey);
	    var nextKeys = targetChildren.map(getKey);
	    var entering = new Set(nextKeys.filter(function (key) { return finishedLeaving.hasOwnProperty(key) || prevKeys.indexOf(key) === -1; }));
	    entering.forEach(function (key) { return delete finishedLeaving[key]; });
	    var leaving = prevKeys.filter(function (key) {
	        return !entering.has(key) &&
	            (finishedLeaving.hasOwnProperty(key) || nextKeys.indexOf(key) === -1);
	    });
	    leaving.forEach(function (key) { return (finishedLeaving[key] = false); });
	    var moving = new Set(prevKeys.filter(function (key, i) {
	        var nextIndex = nextKeys.indexOf(key);
	        return !entering.has(key) && nextIndex !== -1 && i !== nextIndex;
	    }));
	    targetChildren.forEach(function (child) {
	        var newChildProps = tslib_1.__assign({}, propsForChild, filterChildProps(child.props));
	        if (entering.has(child.key)) {
	            if (hasMounted || animateOnMount) {
	                newChildProps.initialPose = preEnterPose;
	            }
	            newChildProps._pose = enterPose;
	        }
	        else if (moving.has(child.key) && flipMove) {
	            newChildProps._pose = [enterPose, 'flip'];
	        }
	        else {
	            newChildProps._pose = enterPose;
	        }
	        children.push(cloneElement(child, newChildProps));
	    });
	    leaving.forEach(function (key) {
	        var child = displayedChildren.find(function (c) { return c.key === key; });
	        var newChild = cloneElement(child, tslib_1.__assign({ _pose: exitPose, onPoseComplete: function () { return scheduleChildRemoval(key); }, popFromFlow: flipMove }, propsForChild, filterChildProps(child.props)));
	        var insertionIndex = prevKeys.indexOf(key);
	        children.splice(insertionIndex, 0, newChild);
	    });
	    return { children: children };
	};
	var handleChildrenTransitions = (function (props, state) { return (tslib_1.__assign({ hasMounted: true }, handleTransition(props, state))); });
	var makeChildList = function (children) {
	    var list = [];
	    Children.forEach(children, function (child) { return child && list.push(child); });
	    return list;
	};
	
	var Transition = (function (_super) {
	    tslib_1.__extends(Transition, _super);
	    function Transition() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            children: [],
	            incomingChildren: [],
	            finishedLeaving: {},
	            scheduleChildRemoval: function (key) { return _this.removeChild(key); }
	        };
	        return _this;
	    }
	    Transition.prototype.removeChild = function (key) {
	        var _a = this.state, children = _a.children, finishedLeaving = _a.finishedLeaving;
	        var _b = this.props, enterAfterExit = _b.enterAfterExit, onRest = _b.onRest;
	        if (!finishedLeaving.hasOwnProperty(key))
	            return;
	        finishedLeaving[key] = true;
	        if (!Object.keys(finishedLeaving).every(function (leavingKey) { return finishedLeaving[leavingKey]; })) {
	            return;
	        }
	        var targetChildren = children.filter(function (child) { return !finishedLeaving.hasOwnProperty(child.key); });
	        var newState = enterAfterExit
	            ? tslib_1.__assign({ finishedLeaving: {} }, handleChildrenTransitions(tslib_1.__assign({}, this.props, { enterAfterExit: false }), tslib_1.__assign({}, this.state, { children: targetChildren }))) : {
	            finishedLeaving: {},
	            children: targetChildren
	        };
	        this.setState(newState, onRest);
	    };
	    Transition.prototype.shouldComponentUpdate = function (nextProps, nextState) {
	        return this.state !== nextState;
	    };
	    Transition.prototype.render = function () {
	        return React.createElement(React.Fragment, null, this.state.children);
	    };
	    Transition.defaultProps = {
	        flipMove: false,
	        enterAfterExit: false,
	        preEnterPose: 'exit',
	        enterPose: 'enter',
	        exitPose: 'exit'
	    };
	    Transition.getDerivedStateFromProps = handleChildrenTransitions;
	    return Transition;
	}(React.Component));
	
	var PoseGroup = (function (_super) {
	    tslib_1.__extends(PoseGroup, _super);
	    function PoseGroup() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PoseGroup.prototype.render = function () {
	        var _a = this.props, children = _a.children, props = tslib_1.__rest(_a, ["children"]);
	        return React.createElement(Transition, tslib_1.__assign({}, props), children);
	    };
	    PoseGroup.defaultProps = {
	        flipMove: true
	    };
	    return PoseGroup;
	}(React.PureComponent));
	
	exports.default = posed;
	exports.Transition = Transition;
	exports.PoseGroup = PoseGroup;


/***/ }),

/***/ 7:
/***/ (function(module, exports) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var clamp = function (min, max) { return function (v) { return Math.max(Math.min(v, max), min); }; };
	var contains = function (term) { return function (v) { return (typeof v === 'string' && v.indexOf(term) !== -1); }; };
	var createUnitType = function (unit) { return ({
	    test: contains(unit),
	    parse: parseFloat,
	    transform: function (v) { return "" + v + unit; }
	}); };
	var isFirstChars = function (term) { return function (v) { return (typeof v === 'string' && v.indexOf(term) === 0); }; };
	exports.getValueFromFunctionString = function (value) { return value.substring(value.indexOf('(') + 1, value.lastIndexOf(')')); };
	exports.splitCommaDelimited = function (value) { return typeof value === 'string' ? value.split(/,\s*/) : [value]; };
	function splitColorValues(terms) {
	    var numTerms = terms.length;
	    return function (v) {
	        var values = {};
	        var valuesArray = exports.splitCommaDelimited(exports.getValueFromFunctionString(v));
	        for (var i = 0; i < numTerms; i++) {
	            values[terms[i]] = (valuesArray[i] !== undefined) ? parseFloat(valuesArray[i]) : 1;
	        }
	        return values;
	    };
	}
	exports.splitColorValues = splitColorValues;
	exports.number = {
	    test: function (v) { return typeof v === 'number'; },
	    parse: parseFloat,
	    transform: function (v) { return v; }
	};
	exports.alpha = __assign({}, exports.number, { transform: clamp(0, 1) });
	exports.degrees = createUnitType('deg');
	exports.percent = createUnitType('%');
	exports.px = createUnitType('px');
	exports.scale = __assign({}, exports.number, { default: 1 });
	var FLOAT_REGEX = /(-)?(\d[\d\.]*)/g;
	var generateToken = function (token) { return '${' + token + '}'; };
	exports.complex = {
	    test: function (v) {
	        var matches = v.match && v.match(FLOAT_REGEX);
	        return (matches !== undefined && matches.constructor === Array && matches.length > 1);
	    },
	    parse: function (v) {
	        var parsedValue = {};
	        v.match(FLOAT_REGEX).forEach(function (value, i) { return parsedValue[i] = parseFloat(value); });
	        return parsedValue;
	    },
	    createTransformer: function (prop) {
	        var counter = 0;
	        var template = prop.replace(FLOAT_REGEX, function () { return generateToken("" + counter++); });
	        return function (v) {
	            var output = template;
	            for (var key in v) {
	                if (v.hasOwnProperty(key)) {
	                    output = output.replace(generateToken(key), v[key].toString());
	                }
	            }
	            return output;
	        };
	    }
	};
	var clampRgbUnit = clamp(0, 255);
	exports.rgbUnit = __assign({}, exports.number, { transform: function (v) { return Math.round(clampRgbUnit(v)); } });
	var rgbaTemplate = function (_a) {
	    var red = _a.red, green = _a.green, blue = _a.blue, _b = _a.alpha, alpha = _b === void 0 ? 1 : _b;
	    return "rgba(" + red + ", " + green + ", " + blue + ", " + alpha + ")";
	};
	exports.rgba = {
	    test: isFirstChars('rgb'),
	    parse: splitColorValues(['red', 'green', 'blue', 'alpha']),
	    transform: function (_a) {
	        var red = _a.red, green = _a.green, blue = _a.blue, alpha = _a.alpha;
	        return rgbaTemplate({
	            red: exports.rgbUnit.transform(red),
	            green: exports.rgbUnit.transform(green),
	            blue: exports.rgbUnit.transform(blue),
	            alpha: alpha
	        });
	    }
	};
	var hslaTemplate = function (_a) {
	    var hue = _a.hue, saturation = _a.saturation, lightness = _a.lightness, _b = _a.alpha, alpha = _b === void 0 ? 1 : _b;
	    return "hsla(" + hue + ", " + saturation + ", " + lightness + ", " + alpha + ")";
	};
	exports.hsla = {
	    test: isFirstChars('hsl'),
	    parse: splitColorValues(['hue', 'saturation', 'lightness', 'alpha']),
	    transform: function (_a) {
	        var hue = _a.hue, saturation = _a.saturation, lightness = _a.lightness, alpha = _a.alpha;
	        return hslaTemplate({
	            hue: Math.round(hue),
	            saturation: exports.percent.transform(saturation),
	            lightness: exports.percent.transform(lightness),
	            alpha: alpha
	        });
	    }
	};
	exports.hex = __assign({}, exports.rgba, { test: isFirstChars('#'), parse: function (v) {
	        var r, g, b;
	        if (v.length > 4) {
	            r = v.substr(1, 2);
	            g = v.substr(3, 2);
	            b = v.substr(5, 2);
	        }
	        else {
	            r = v.substr(1, 1);
	            g = v.substr(2, 1);
	            b = v.substr(3, 1);
	            r += r;
	            g += g;
	            b += b;
	        }
	        return {
	            red: parseInt(r, 16),
	            green: parseInt(g, 16),
	            blue: parseInt(b, 16),
	            alpha: 1
	        };
	    } });
	var isRgba = function (v) { return v.red !== undefined; };
	var isHsla = function (v) { return v.hue !== undefined; };
	exports.color = {
	    test: function (v) { return exports.rgba.test(v) || exports.hsla.test(v) || exports.hex.test(v); },
	    parse: function (v) {
	        if (exports.rgba.test(v)) {
	            return exports.rgba.parse(v);
	        }
	        else if (exports.hsla.test(v)) {
	            return exports.hsla.parse(v);
	        }
	        else if (exports.hex.test(v)) {
	            return exports.hex.parse(v);
	        }
	        return v;
	    },
	    transform: function (v) {
	        if (isRgba(v)) {
	            return exports.rgba.transform(v);
	        }
	        else if (isHsla(v)) {
	            return exports.hsla.transform(v);
	        }
	        return v;
	    },
	};
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var styler_1 = __webpack_require__(26);
	var prefixer_1 = __webpack_require__(52);
	var render_1 = __webpack_require__(53);
	var transform_props_1 = __webpack_require__(20);
	var value_types_1 = __webpack_require__(54);
	var cssStyler = styler_1.default({
	    onRead: function (key, _a) {
	        var element = _a.element, preparseOutput = _a.preparseOutput;
	        var valueType = value_types_1.default(key);
	        if (transform_props_1.isTransformProp(key)) {
	            return (valueType)
	                ? valueType.default || 0
	                : 0;
	        }
	        else {
	            var domValue = window.getComputedStyle(element, null).getPropertyValue(prefixer_1.default(key, true)) || 0;
	            return (preparseOutput && valueType && valueType.parse) ? valueType.parse(domValue) : domValue;
	        }
	    },
	    onRender: function (state, _a, changedValues) {
	        var element = _a.element, enableHardwareAcceleration = _a.enableHardwareAcceleration;
	        element.style.cssText += render_1.default(state, changedValues, enableHardwareAcceleration);
	    },
	    aliasMap: render_1.aliasMap
	});
	exports.default = function (element, props) {
	    return cssStyler(__assign({ element: element, enableHardwareAcceleration: true, preparseOutput: true }, props));
	};
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(30);
	var camelCache = new Map();
	var dashCache = new Map();
	var prefixes = ['Webkit', 'Moz', 'O', 'ms', ''];
	var numPrefixes = prefixes.length;
	var testElement;
	var testPrefix = function (key) {
	    if (typeof document === 'undefined')
	        return;
	    testElement = testElement || document.createElement('div');
	    for (var i = 0; i < numPrefixes; i++) {
	        var prefix = prefixes[i];
	        var noPrefix = (prefix === '');
	        var prefixedPropertyName = noPrefix ? key : prefix + key.charAt(0).toUpperCase() + key.slice(1);
	        if (prefixedPropertyName in testElement.style) {
	            camelCache.set(key, prefixedPropertyName);
	            dashCache.set(key, "" + (noPrefix ? '' : '-') + utils_1.camelToDash(prefixedPropertyName));
	        }
	    }
	};
	exports.default = function (key, asDashCase) {
	    if (asDashCase === void 0) { asDashCase = false; }
	    var cache = asDashCase ? dashCache : camelCache;
	    if (!cache.has(key))
	        testPrefix(key);
	    return cache.get(key) || key;
	};
	//# sourceMappingURL=prefixer.js.map

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var transform_props_1 = __webpack_require__(20);
	var prefixer_1 = __webpack_require__(52);
	var value_types_1 = __webpack_require__(54);
	exports.aliasMap = {
	    x: 'translateX',
	    y: 'translateY',
	    z: 'translateZ',
	    originX: 'transformOriginX',
	    originY: 'transformOriginY',
	    originZ: 'transformOriginZ'
	};
	var NUMBER = 'number';
	var OBJECT = 'object';
	var COLON = ':';
	var SEMI_COLON = ';';
	var TRANSFORM_ORIGIN = 'transform-origin';
	var TRANSFORM = 'transform';
	var TRANSLATE_Z = 'translateZ';
	var TRANSFORM_NONE = ';transform: none';
	var styleRule = function (key, value) { return "" + SEMI_COLON + key + COLON + value; };
	function buildStylePropertyString(state, changedValues, enableHardwareAcceleration) {
	    if (changedValues === void 0) { changedValues = true; }
	    if (enableHardwareAcceleration === void 0) { enableHardwareAcceleration = true; }
	    var valuesToChange = (changedValues === true) ? Object.keys(state) : changedValues;
	    var propertyString = '';
	    var transformString = '';
	    var hasTransformOrigin = false;
	    var transformIsDefault = true;
	    var hasTransform = false;
	    var transformHasZ = false;
	    var numChangedValues = valuesToChange.length;
	    for (var i = 0; i < numChangedValues; i++) {
	        var key = valuesToChange[i];
	        if (transform_props_1.isTransformProp(key)) {
	            hasTransform = true;
	            for (var stateKey in state) {
	                if (transform_props_1.isTransformProp(stateKey) && valuesToChange.indexOf(stateKey) === -1) {
	                    valuesToChange.push(stateKey);
	                }
	            }
	            break;
	        }
	    }
	    valuesToChange.sort(transform_props_1.sortTransformProps);
	    var totalNumChangedValues = valuesToChange.length;
	    for (var i = 0; i < totalNumChangedValues; i++) {
	        var key = valuesToChange[i];
	        var isTransformKey = transform_props_1.isTransformProp(key);
	        var value = state[key];
	        var valueType = value_types_1.default(key);
	        if (isTransformKey) {
	            if ((valueType.default && value !== valueType.default) || (!valueType.default && value !== 0)) {
	                transformIsDefault = false;
	            }
	        }
	        if (valueType && (typeof value === NUMBER || typeof value === OBJECT) && valueType.transform) {
	            value = valueType.transform(value);
	        }
	        if (isTransformKey) {
	            transformString += key + '(' + value + ') ';
	            transformHasZ = (key === TRANSLATE_Z) ? true : transformHasZ;
	        }
	        else if (transform_props_1.isTransformOriginProp(key)) {
	            state[key] = value;
	            hasTransformOrigin = true;
	        }
	        else {
	            propertyString += styleRule(prefixer_1.default(key, true), value);
	        }
	    }
	    if (hasTransformOrigin) {
	        propertyString += styleRule(TRANSFORM_ORIGIN, (state.transformOriginX || 0) + " " + (state.transformOriginY || 0) + " " + (state.transformOriginZ || 0));
	    }
	    if (hasTransform) {
	        if (!transformHasZ && enableHardwareAcceleration) {
	            transformString += TRANSLATE_Z + "(0)";
	        }
	        propertyString += styleRule(TRANSFORM, transformIsDefault ? TRANSFORM_NONE : transformString);
	    }
	    return propertyString;
	}
	exports.default = buildStylePropertyString;
	//# sourceMappingURL=render.js.map

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var axes = ['', 'X', 'Y', 'Z'];
	var order = ['translate', 'scale', 'rotate', 'skew', 'transformPerspective'];
	var TRANSFORM_ORIGIN_X = 'transformOriginX';
	var TRANSFORM_ORIGIN_Y = 'transformOriginY';
	var transformProps = order.reduce(function (acc, key) {
	    return axes.reduce(function (axesAcc, axesKey) {
	        axesAcc.push(key + axesKey);
	        return axesAcc;
	    }, acc);
	}, ['x', 'y', 'z']);
	var transformPropDictionary = transformProps.reduce(function (dict, key) {
	    dict[key] = true;
	    return dict;
	}, {});
	exports.isTransformProp = function (key) { return transformPropDictionary[key] === true; };
	exports.sortTransformProps = function (a, b) { return transformProps.indexOf(a) - transformProps.indexOf(b); };
	exports.isTransformOriginProp = function (key) { return key === TRANSFORM_ORIGIN_X || key === TRANSFORM_ORIGIN_Y; };
	//# sourceMappingURL=transform-props.js.map

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var style_value_types_1 = __webpack_require__(7);
	var valueTypes = {
	    color: style_value_types_1.color,
	    backgroundColor: style_value_types_1.color,
	    outlineColor: style_value_types_1.color,
	    fill: style_value_types_1.color,
	    stroke: style_value_types_1.color,
	    borderColor: style_value_types_1.color,
	    borderTopColor: style_value_types_1.color,
	    borderRightColor: style_value_types_1.color,
	    borderBottomColor: style_value_types_1.color,
	    borderLeftColor: style_value_types_1.color,
	    borderRadius: style_value_types_1.px,
	    width: style_value_types_1.px,
	    maxWidth: style_value_types_1.px,
	    height: style_value_types_1.px,
	    maxHeight: style_value_types_1.px,
	    top: style_value_types_1.px,
	    left: style_value_types_1.px,
	    bottom: style_value_types_1.px,
	    right: style_value_types_1.px,
	    rotate: style_value_types_1.degrees,
	    rotateX: style_value_types_1.degrees,
	    rotateY: style_value_types_1.degrees,
	    rotateZ: style_value_types_1.degrees,
	    scale: style_value_types_1.scale,
	    scaleX: style_value_types_1.scale,
	    scaleY: style_value_types_1.scale,
	    scaleZ: style_value_types_1.scale,
	    skewX: style_value_types_1.degrees,
	    skewY: style_value_types_1.degrees,
	    distance: style_value_types_1.px,
	    translateX: style_value_types_1.px,
	    translateY: style_value_types_1.px,
	    translateZ: style_value_types_1.px,
	    perspective: style_value_types_1.px,
	    opacity: style_value_types_1.alpha,
	    transformOriginX: style_value_types_1.percent,
	    transformOriginY: style_value_types_1.percent,
	    transformOriginZ: style_value_types_1.px
	};
	exports.default = function (key) { return valueTypes[key]; };
	//# sourceMappingURL=value-types.js.map

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var css_1 = __webpack_require__(51);
	var render_1 = __webpack_require__(53);
	exports.buildStyles = render_1.default;
	var styler_1 = __webpack_require__(26);
	exports.createStyler = styler_1.default;
	var svg_1 = __webpack_require__(55);
	var cache = new WeakMap();
	var createDOMStyler = function (node, props) {
	    var styler = (node instanceof SVGElement) ? svg_1.default(node) : css_1.default(node, props);
	    cache.set(node, styler);
	    return styler;
	};
	var getStyler = function (node, props) { return cache.has(node) ? cache.get(node) : createDOMStyler(node, props); };
	function default_1(nodeOrSelector, props) {
	    var node = (typeof nodeOrSelector === 'string')
	        ? document.querySelector(nodeOrSelector)
	        : nodeOrSelector;
	    return getStyler(node, props);
	}
	exports.default = default_1;
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var framesync_1 = __webpack_require__(4);
	var createStyler = function (_a) {
	    var onRead = _a.onRead, onRender = _a.onRender, _b = _a.aliasMap, aliasMap = _b === void 0 ? {} : _b, _c = _a.useCache, useCache = _c === void 0 ? true : _c;
	    return function (props) {
	        var state = {};
	        var changedValues = [];
	        var hasChanged = false;
	        var setValue = function (unmappedKey, value) {
	            var key = aliasMap[unmappedKey] || unmappedKey;
	            var currentValue = state[key];
	            state[key] = value;
	            if (state[key] !== currentValue) {
	                if (changedValues.indexOf(key) === -1) {
	                    changedValues.push(key);
	                }
	                if (!hasChanged) {
	                    hasChanged = true;
	                    framesync_1.onFrameRender(render);
	                }
	            }
	        };
	        function render(forceRender) {
	            if (forceRender === void 0) { forceRender = false; }
	            if (forceRender || hasChanged) {
	                onRender(state, props, changedValues);
	                hasChanged = false;
	                changedValues.length = 0;
	            }
	            return this;
	        }
	        return {
	            get: function (unmappedKey) {
	                var key = aliasMap[unmappedKey] || unmappedKey;
	                return (key)
	                    ? (useCache && state[key] !== undefined)
	                        ? state[key]
	                        : onRead(key, props)
	                    : state;
	            },
	            set: function (values, value) {
	                if (typeof values === 'string') {
	                    if (value !== undefined) {
	                        setValue(values, value);
	                    }
	                    else {
	                        return function (v) { return setValue(values, v); };
	                    }
	                }
	                else {
	                    for (var key in values) {
	                        if (values.hasOwnProperty(key)) {
	                            setValue(key, values[key]);
	                        }
	                    }
	                }
	                return this;
	            },
	            render: render,
	        };
	    };
	};
	exports.default = createStyler;
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 30:
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
	var REPLACE_TEMPLATE = '$1-$2';
	exports.camelToDash = function (str) { return str.replace(CAMEL_CASE_PATTERN, REPLACE_TEMPLATE).toLowerCase(); };
	exports.setDomAttrs = function (element, attrs) {
	    for (var key in attrs) {
	        if (attrs.hasOwnProperty(key)) {
	            element.setAttribute(key, attrs[key]);
	        }
	    }
	};
	//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(30);
	var transform_props_1 = __webpack_require__(20);
	var ZERO_NOT_ZERO = 0.0000001;
	var percentToPixels = function (percent, length) {
	    return (percent / 100) * length + 'px';
	};
	var build = function (state, dimensions, isPath, pathLength) {
	    var hasTransform = false;
	    var hasDashArray = false;
	    var props = {};
	    var dashArrayStyles = isPath ? {
	        pathLength: '0',
	        pathSpacing: "" + pathLength
	    } : undefined;
	    var scale = state.scale !== undefined ? state.scale || ZERO_NOT_ZERO : state.scaleX || 1;
	    var scaleY = state.scaleY !== undefined ? state.scaleY || ZERO_NOT_ZERO : scale || 1;
	    var transformOriginX = dimensions.width * ((state.originX || 50) / 100) + dimensions.x;
	    var transformOriginY = dimensions.height * ((state.originY || 50) / 100) + dimensions.y;
	    var scaleTransformX = -transformOriginX * (scale * 1);
	    var scaleTransformY = -transformOriginY * (scaleY * 1);
	    var scaleReplaceX = transformOriginX / scale;
	    var scaleReplaceY = transformOriginY / scaleY;
	    var transform = {
	        translate: "translate(" + state.translateX + ", " + state.translateY + ") ",
	        scale: "translate(" + scaleTransformX + ", " + scaleTransformY + ") scale(" + scale + ", " + scaleY + ") translate(" + scaleReplaceX + ", " + scaleReplaceY + ") ",
	        rotate: "rotate(" + state.rotate + ", " + transformOriginX + ", " + transformOriginY + ") ",
	        skewX: "skewX(" + state.skewX + ") ",
	        skewY: "skewY(" + state.skewY + ") "
	    };
	    for (var key in state) {
	        if (state.hasOwnProperty(key)) {
	            var value = state[key];
	            if (transform_props_1.isTransformProp(key)) {
	                hasTransform = true;
	            }
	            else if (isPath && (key === 'pathLength' || key === 'pathSpacing') && typeof value === 'number') {
	                hasDashArray = true;
	                dashArrayStyles[key] = percentToPixels(value, pathLength);
	            }
	            else if (isPath && key === 'pathOffset') {
	                props['stroke-dashoffset'] = percentToPixels(-value, pathLength);
	            }
	            else {
	                props[utils_1.camelToDash(key)] = value;
	            }
	        }
	    }
	    if (hasDashArray) {
	        props['stroke-dasharray'] = dashArrayStyles.pathLength + ' ' + dashArrayStyles.pathSpacing;
	    }
	    if (hasTransform) {
	        props.transform = '';
	        for (var key in transform) {
	            if (transform.hasOwnProperty(key)) {
	                var defaultValue = (key === 'scale') ? '1' : '0';
	                props.transform += transform[key].replace(/undefined/g, defaultValue);
	            }
	        }
	    }
	    return props;
	};
	exports.default = build;
	//# sourceMappingURL=build.js.map

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var transform_props_1 = __webpack_require__(20);
	var styler_1 = __webpack_require__(26);
	var utils_1 = __webpack_require__(30);
	var build_1 = __webpack_require__(103);
	var value_types_1 = __webpack_require__(104);
	var svgStyler = styler_1.default({
	    onRead: function (key, _a) {
	        var element = _a.element;
	        if (!transform_props_1.isTransformProp(key)) {
	            return element.getAttribute(key);
	        }
	        else {
	            var valueType = value_types_1.default(key);
	            return valueType ? valueType.default : 0;
	        }
	    },
	    onRender: function (state, _a, changedValues) {
	        var dimensions = _a.dimensions, element = _a.element, isPath = _a.isPath, pathLength = _a.pathLength;
	        utils_1.setDomAttrs(element, build_1.default(state, dimensions, isPath, pathLength));
	    },
	    aliasMap: {
	        x: 'translateX',
	        y: 'translateY',
	        background: 'fill'
	    }
	});
	exports.default = function (element) {
	    var _a = element.getBBox(), x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	    var props = {
	        element: element,
	        dimensions: { x: x, y: y, width: width, height: height },
	        isPath: false
	    };
	    if (element.tagName === 'path') {
	        props.isPath = true;
	        props.pathLength = element.getTotalLength();
	    }
	    return svgStyler(props);
	};
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var style_value_types_1 = __webpack_require__(7);
	var valueTypes = {
	    fill: style_value_types_1.color,
	    stroke: style_value_types_1.color,
	    scale: style_value_types_1.scale,
	    scaleX: style_value_types_1.scale,
	    scaleY: style_value_types_1.scale,
	    opacity: style_value_types_1.alpha,
	    fillOpacity: style_value_types_1.alpha,
	    strokeOpacity: style_value_types_1.alpha
	};
	exports.default = function (key) { return valueTypes[key]; };
	//# sourceMappingURL=value-types.js.map

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global global, define, System, Reflect, Promise */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	    __extends = function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
	                t[p[i]] = s[p[i]];
	        return t;
	    };
	
	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };
	
	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };
	
	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };
	
	    __awaiter = function (thisArg, _arguments, P, generator) {
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };
	
	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };
	
	    __exportStar = function (m, exports) {
	        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	    };
	
	    __values = function (o) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	        if (m) return m.call(o);
	        return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	    };
	
	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };
	
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };
	
	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };
	
	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };
	
	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	    };
	
	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };
	
	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };
	
	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	        result["default"] = mod;
	        return result;
	    };
	
	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };
	
	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactPose = __webpack_require__(289);
	
	var _reactPose2 = _interopRequireDefault(_reactPose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  Container: _reactPose2.default.ol({
	    active: {
	      beforeChildren: false,
	      delayChildren: 200,
	      staggerChildren: 50,
	      opacity: 1
	    },
	    inactive: {
	      beforeChildren: false,
	      delayChildren: 200,
	      staggerChildren: 50,
	      delay: 180,
	      opacity: 0
	    }
	  }),
	
	  Column: _reactPose2.default.li({
	    active: {
	      y: 0,
	      beforeChildren: true,
	      delayChildren: 200,
	      staggerChildren: 50,
	      opacity: 1
	    },
	    inactive: {
	      y: 20,
	      delayChildren: 200,
	      staggerChildren: 50,
	      opacity: 0
	    }
	  }),
	
	  Row: _reactPose2.default.div({
	    active: { y: 0, opacity: 1 },
	    inactive: { y: 10, opacity: 0 }
	  })
	};
	module.exports = exports['default'];

/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AnimatedTable = __webpack_require__(208);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createElement(
	  'div',
	  { title: '15, 16 & 17 October' },
	  _react2.default.createElement(
	    _AnimatedTable.Container,
	    { className: 'SchedulePage-columns is-firstPart' },
	    _react2.default.createElement(
	      _AnimatedTable.Column,
	      { className: 'SchedulePage-column' },
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-row' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'SchedulePage-title no-topMargin' },
	          '15'
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Container,
	        { className: 'SchedulePage-columns' },
	        _react2.default.createElement(
	          _AnimatedTable.Column,
	          { className: 'SchedulePage-column' },
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-row' },
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://www.google.pt/maps/place/GNRation/@41.5646428,-8.4807824,13z/data=!4m5!3m4!1s0xd24fee9ae15fe63:0xf715da419f911455!8m2!3d41.5531265!4d-8.42622',
	                className: 'SchedulePage-room no-locationDot'
	              },
	              'Gnration ',
	              _react2.default.createElement('br', null),
	              ' Room 1'
	            )
	          ),
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-entry' },
	            _react2.default.createElement(
	              'p',
	              { className: 'SchedulePage-entryTime' },
	              '10:00'
	            ),
	            _react2.default.createElement(
	              'a',
	              {
	                href: '/designing-calm-technology',
	                className: 'SchedulePage-entryTitle'
	              },
	              'Designing Calm Technology pt.1',
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'SchedulePage-entrySpeaker' },
	                'by Amber Case'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-entry is-small' },
	            _react2.default.createElement(
	              'p',
	              { className: 'SchedulePage-entryTime' },
	              '13:00'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'SchedulePage-entryTitle' },
	              'Lunch'
	            )
	          ),
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-entry' },
	            _react2.default.createElement(
	              'p',
	              { className: 'SchedulePage-entryTime' },
	              '14:00'
	            ),
	            _react2.default.createElement(
	              'a',
	              {
	                href: '/designing-calm-technology',
	                className: 'SchedulePage-entryTitle'
	              },
	              'Designing Calm Technology pt.2',
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'SchedulePage-entrySpeaker' },
	                'by Amber Case'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _AnimatedTable.Column,
	          { className: 'SchedulePage-column' },
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-row' },
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://www.google.pt/maps/place/GNRation/@41.5646428,-8.4807824,13z/data=!4m5!3m4!1s0xd24fee9ae15fe63:0xf715da419f911455!8m2!3d41.5531265!4d-8.42622',
	                className: 'SchedulePage-room no-locationDot'
	              },
	              'Gnration ',
	              _react2.default.createElement('br', null),
	              ' Room 2'
	            )
	          ),
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-entry' },
	            _react2.default.createElement(
	              'p',
	              { className: 'SchedulePage-entryTime' },
	              '10:00'
	            ),
	            _react2.default.createElement(
	              'a',
	              {
	                href: '/smart-responsive-interface-design-patterns',
	                className: 'SchedulePage-entryTitle'
	              },
	              'Smart Responsive Interface Design Patterns pt.1',
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'SchedulePage-entrySpeaker' },
	                'by Vitaly Friedman'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-entry is-small' },
	            _react2.default.createElement(
	              'p',
	              { className: 'SchedulePage-entryTime' },
	              '13:00'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'SchedulePage-entryTitle' },
	              'Lunch'
	            )
	          ),
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-entry' },
	            _react2.default.createElement(
	              'p',
	              { className: 'SchedulePage-entryTime' },
	              '14:00'
	            ),
	            _react2.default.createElement(
	              'a',
	              {
	                href: '/smart-responsive-interface-design-patterns',
	                className: 'SchedulePage-entryTitle'
	              },
	              'Smart Responsive Interface Design Patterns pt.2',
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'SchedulePage-entrySpeaker' },
	                'by Vitaly Friedman'
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _AnimatedTable.Column,
	      { className: 'SchedulePage-column' },
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-row' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'SchedulePage-title' },
	          '16'
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Container,
	        { className: 'SchedulePage-columns' },
	        _react2.default.createElement(
	          _AnimatedTable.Column,
	          { className: 'SchedulePage-column' },
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-row' },
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://www.google.pt/maps/place/GNRation/@41.5646428,-8.4807824,13z/data=!4m5!3m4!1s0xd24fee9ae15fe63:0xf715da419f911455!8m2!3d41.5531265!4d-8.42622',
	                className: 'SchedulePage-room no-locationDot'
	              },
	              'Gnration ',
	              _react2.default.createElement('br', null),
	              ' Room 1'
	            )
	          ),
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-entry' },
	            _react2.default.createElement(
	              'p',
	              { className: 'SchedulePage-entryTime' },
	              '10:00'
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: '/design-is-a-job', className: 'SchedulePage-entryTitle' },
	              'Design is a Job pt.1',
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'SchedulePage-entrySpeaker' },
	                'by Mike Monteiro'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-entry is-small' },
	            _react2.default.createElement(
	              'p',
	              { className: 'SchedulePage-entryTime' },
	              '13:00'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'SchedulePage-entryTitle' },
	              'Lunch'
	            )
	          ),
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-entry' },
	            _react2.default.createElement(
	              'p',
	              { className: 'SchedulePage-entryTime' },
	              '14:00'
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: '/design-is-a-job', className: 'SchedulePage-entryTitle' },
	              'Design is a Job pt.2',
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'SchedulePage-entrySpeaker' },
	                'by Mike Monteiro'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _AnimatedTable.Column,
	          { className: 'SchedulePage-column' },
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-row' },
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://www.google.pt/maps/place/GNRation/@41.5646428,-8.4807824,13z/data=!4m5!3m4!1s0xd24fee9ae15fe63:0xf715da419f911455!8m2!3d41.5531265!4d-8.42622',
	                className: 'SchedulePage-room no-locationDot'
	              },
	              'Gnration ',
	              _react2.default.createElement('br', null),
	              ' Room 2'
	            )
	          ),
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-entry' },
	            _react2.default.createElement(
	              'p',
	              { className: 'SchedulePage-entryTime' },
	              '10:00'
	            ),
	            _react2.default.createElement(
	              'a',
	              {
	                href: '/jobs-to-be-done-for-better-product-strategy',
	                className: 'SchedulePage-entryTitle'
	              },
	              'Jobs-to-Be-Done for Better Product Strategy pt.1',
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'SchedulePage-entrySpeaker' },
	                'by Stephanie Troeth'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-entry is-small' },
	            _react2.default.createElement(
	              'p',
	              { className: 'SchedulePage-entryTime' },
	              '13:00'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'SchedulePage-entryTitle' },
	              'Lunch'
	            )
	          ),
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-entry' },
	            _react2.default.createElement(
	              'p',
	              { className: 'SchedulePage-entryTime' },
	              '14:00'
	            ),
	            _react2.default.createElement(
	              'a',
	              {
	                href: '/jobs-to-be-done-for-better-product-strategy',
	                className: 'SchedulePage-entryTitle'
	              },
	              'Jobs-to-Be-Done for Better Product Strategy pt.2',
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'SchedulePage-entrySpeaker' },
	                'by Stephanie Troeth'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Container,
	        { className: 'SchedulePage-columns' },
	        _react2.default.createElement(
	          _AnimatedTable.Column,
	          { className: 'SchedulePage-column' },
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-row' },
	            _react2.default.createElement(
	              'a',
	              {
	                className: 'SchedulePage-room',
	                href: 'https://www.google.pt/maps/place/Arco+Da+Porta+Nova/@41.5414507,-8.4246834,17z/data=!4m5!3m4!1s0xd24feddbb951979:0x79eaea00892f7625!8m2!3d41.5502494!4d-8.4294138'
	              },
	              'Braga City Center, Arco da Porta Nova'
	            )
	          ),
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-entry  is-small' },
	            _react2.default.createElement(
	              'p',
	              { className: 'SchedulePage-entryTime' },
	              '16:00'
	            ),
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://subvisual.typeform.com/to/l9DwYF',
	                className: 'SchedulePage-entryTitle'
	              },
	              'Free Walking Tour'
	            )
	          ),
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-row' },
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://www.google.pt/maps/place/GNRation/@41.5646428,-8.4807824,13z/data=!4m5!3m4!1s0xd24fee9ae15fe63:0xf715da419f911455!8m2!3d41.5531265!4d-8.42622',
	                className: 'SchedulePage-room'
	              },
	              'Startup Braga, Gnration'
	            )
	          ),
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-entry no-margin' },
	            _react2.default.createElement(
	              'p',
	              { className: 'SchedulePage-entryTime' },
	              '18:30'
	            ),
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://www.meetup.com/pt-BR/bragadesign/events/255085502/',
	                className: 'SchedulePage-entryTitle'
	              },
	              'Meetup:',
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'SchedulePage-entrySpeaker' },
	                'Braga.Design + Braga.JS'
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _AnimatedTable.Column,
	      { className: 'SchedulePage-column' },
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-row' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'SchedulePage-title' },
	          '17'
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Container,
	        { className: 'SchedulePage-columns' },
	        _react2.default.createElement(
	          _AnimatedTable.Column,
	          { className: 'SchedulePage-column' },
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-row' },
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://www.google.pt/maps/place/GNRation/@41.5646428,-8.4807824,13z/data=!4m5!3m4!1s0xd24fee9ae15fe63:0xf715da419f911455!8m2!3d41.5531265!4d-8.42622',
	                className: 'SchedulePage-room no-locationDot'
	              },
	              'Gnration ',
	              _react2.default.createElement('br', null),
	              ' Room 1'
	            )
	          ),
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-entry' },
	            _react2.default.createElement(
	              'p',
	              { className: 'SchedulePage-entryTime' },
	              '10:00'
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: '/css-in-2018', className: 'SchedulePage-entryTitle' },
	              'CSS and SVG in 2018 pt.1',
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'SchedulePage-entrySpeaker' },
	                'by Lea Verou & Chris Lilley'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-entry is-small' },
	            _react2.default.createElement(
	              'p',
	              { className: 'SchedulePage-entryTime' },
	              '13:00'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'SchedulePage-entryTitle' },
	              'Lunch'
	            )
	          ),
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-entry' },
	            _react2.default.createElement(
	              'p',
	              { className: 'SchedulePage-entryTime' },
	              '14:00'
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: '/css-in-2018', className: 'SchedulePage-entryTitle' },
	              'CSS and SVG in 2018 pt.2',
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'SchedulePage-entrySpeaker' },
	                'by Lea Verou & Chris Lilley'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _AnimatedTable.Column,
	          { className: 'SchedulePage-column' },
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-row' },
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://www.google.pt/maps/place/GNRation/@41.5646428,-8.4807824,13z/data=!4m5!3m4!1s0xd24fee9ae15fe63:0xf715da419f911455!8m2!3d41.5531265!4d-8.42622',
	                className: 'SchedulePage-room no-locationDot'
	              },
	              'Gnration ',
	              _react2.default.createElement('br', null),
	              ' Room 2'
	            )
	          ),
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-entry' },
	            _react2.default.createElement(
	              'p',
	              { className: 'SchedulePage-entryTime' },
	              '10:00'
	            ),
	            _react2.default.createElement(
	              'a',
	              {
	                href: '/designing-for-delight',
	                className: 'SchedulePage-entryTitle'
	              },
	              'Designing for Delight pt.1',
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'SchedulePage-entrySpeaker' },
	                'by Jared Spool & Dana Chisnell'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-entry is-small' },
	            _react2.default.createElement(
	              'p',
	              { className: 'SchedulePage-entryTime' },
	              '13:00'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'SchedulePage-entryTitle' },
	              'Lunch'
	            )
	          ),
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-entry' },
	            _react2.default.createElement(
	              'p',
	              { className: 'SchedulePage-entryTime' },
	              '14:00'
	            ),
	            _react2.default.createElement(
	              'a',
	              {
	                href: '/designing-for-delight',
	                className: 'SchedulePage-entryTitle'
	              },
	              'Designing for Delight pt.2',
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'SchedulePage-entrySpeaker' },
	                'by Jared Spool & Dana Chisnell'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Container,
	        { className: 'SchedulePage-columns' },
	        _react2.default.createElement(
	          _AnimatedTable.Column,
	          { className: 'SchedulePage-column' },
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-row' },
	            _react2.default.createElement(
	              'a',
	              {
	                className: 'SchedulePage-room',
	                href: 'https://www.google.pt/maps/place/Arco+Da+Porta+Nova/@41.5414507,-8.4246834,17z/data=!4m5!3m4!1s0xd24feddbb951979:0x79eaea00892f7625!8m2!3d41.5502494!4d-8.4294138'
	              },
	              'Braga City Center, Arco da Porta Nova'
	            )
	          ),
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-entry is-small' },
	            _react2.default.createElement(
	              'p',
	              { className: 'SchedulePage-entryTime' },
	              '16:00'
	            ),
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://subvisual.typeform.com/to/l9DwYF',
	                className: 'SchedulePage-entryTitle'
	              },
	              'Free Walking Tour'
	            )
	          ),
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-row' },
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://www.google.pt/maps/place/GNRation/@41.5646428,-8.4807824,13z/data=!4m5!3m4!1s0xd24fee9ae15fe63:0xf715da419f911455!8m2!3d41.5531265!4d-8.42622',
	                className: 'SchedulePage-room'
	              },
	              'Startup Braga, Gnration'
	            )
	          ),
	          _react2.default.createElement(
	            _AnimatedTable.Row,
	            { className: 'SchedulePage-entry no-margin' },
	            _react2.default.createElement(
	              'p',
	              { className: 'SchedulePage-entryTime' },
	              '18:30'
	            ),
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://www.google.pt/maps/place/GNRation/@41.5531265,-8.4284087,17z/data=!3m1!4b1!4m5!3m4!1s0xd24fee9ae15fe63:0xf715da419f911455!8m2!3d41.5531265!4d-8.42622',
	                className: 'SchedulePage-entryTitle'
	              },
	              'Welcome Drinks'
	            )
	          )
	        )
	      )
	    )
	  )
	);
	module.exports = exports['default'];

/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AnimatedTable = __webpack_require__(208);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Xing = _react2.default.createElement(
	  'a',
	  {
	    className: 'SchedulePage-link',
	    href: 'https://www.xing.com/en',
	    target: '_blank',
	    rel: 'noopener noreferrer'
	  },
	  'sponsored by Xing'
	);
	
	var Ginetta = _react2.default.createElement(
	  'a',
	  {
	    target: '_blank',
	    rel: 'noopener noreferrer',
	    className: 'SchedulePage-link',
	    href: 'https://ginetta.net/'
	  },
	  'hosted by Ginetta'
	);
	
	exports.default = _react2.default.createElement(
	  'div',
	  { title: '18 & 19 October' },
	  _react2.default.createElement(
	    _AnimatedTable.Container,
	    { className: 'SchedulePage-columns' },
	    _react2.default.createElement(
	      _AnimatedTable.Column,
	      { className: 'SchedulePage-column' },
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-row' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'SchedulePage-title no-topMargin' },
	          '18'
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-row' },
	        _react2.default.createElement(
	          'a',
	          {
	            href: 'https://www.google.pt/maps/place/Altice+Forum+Braga/@41.5414507,-8.4246834,17z/data=!3m1!4b1!4m5!3m4!1s0xd24fc6519e03b3d:0xb47f5e1a7515bd95!8m2!3d41.5414467!4d-8.4224894',
	            className: 'SchedulePage-room'
	          },
	          'Altice Forum Braga ',
	          _react2.default.createElement('br', null),
	          ' Main Room'
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-entry' },
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTime' },
	          '09:00'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTitle' },
	          'Check in'
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-entry' },
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTime' },
	          '09:50'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTitle' },
	          'Opening'
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-entry' },
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTime' },
	          '10:00'
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: '/speakers#jared-spool', className: 'SchedulePage-entryTitle' },
	          'Design is a team sport',
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'SchedulePage-entrySpeaker' },
	            'by Jared Spool'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-entry xl' },
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTime' },
	          '10:45'
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            href: '/speakers#stephanie-troeth',
	            className: 'SchedulePage-entryTitle'
	          },
	          'Behind the Story',
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'SchedulePage-entrySpeaker' },
	            'Stephanie Troeth'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-entry' },
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTime' },
	          '11:30'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTitle' },
	          'Coffe Break ',
	          Xing
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-entry' },
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTime' },
	          '12:15'
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: '/speakers#rails-girls', className: 'SchedulePage-entryTitle' },
	          'Hurdles of Junior Developers and How To Overcome Them',
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'SchedulePage-entrySpeaker' },
	            'by Sabine van der Eijk & Alina Leuca'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-entry' },
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTime' },
	          '13:00'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTitle' },
	          'Lunch'
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-entry l' },
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTime' },
	          '15:00'
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: '/speakers#arne-kittler', className: 'SchedulePage-entryTitle' },
	          'Clarity in Collaboration',
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'SchedulePage-entrySpeaker' },
	            'by Arne Kittler'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-entry' },
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTime' },
	          '15:30'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTitle' },
	          'Talk Shop',
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'SchedulePage-entrySpeaker' },
	            'with Sabine van der Eijk, Alina Leuca and Arne Kittler'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-entry xl' },
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTime' },
	          '15:45'
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            href: '/speakers#vivianne-castillo',
	            className: 'SchedulePage-entryTitle'
	          },
	          'Ethics & Power: Understanding the Role of Shame in UX Research',
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'SchedulePage-entrySpeaker' },
	            'Vivianne Castillo'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-entry' },
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTime' },
	          '16:15'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTitle' },
	          'Coffe Break ',
	          Xing
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-entry xl' },
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTime' },
	          '18:00'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTitle' },
	          'Talk Shop',
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'SchedulePage-entrySpeaker' },
	            'with Vivianne Castillo, Jared Spool, and Stephanie Troeth'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-entry' },
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTime' },
	          '19:00'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTitle' },
	          'Closing'
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-row' },
	        _react2.default.createElement(
	          'a',
	          {
	            href: 'https://www.google.pt/maps/place/Casa+Velha+artbar/@41.5471178,-8.4182091,15.36z/data=!4m8!1m2!2m1!1scasa+velha+near+Parque+Da+Ponte,+N101,+Braga!3m4!1s0x0:0x4d913deb9f7f684f!8m2!3d41.5422586!4d-8.4194005',
	            className: 'SchedulePage-room'
	          },
	          'Casa Velha, Parque da Ponte'
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-entry' },
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTime' },
	          '21:00'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTitle' },
	          'MirrorConf Party ',
	          Ginetta
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _AnimatedTable.Column,
	      { className: 'SchedulePage-column' },
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-row' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'SchedulePage-title' },
	          '19'
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-row' },
	        _react2.default.createElement(
	          'a',
	          {
	            href: 'https://www.google.pt/maps/place/Altice+Forum+Braga/@41.5414507,-8.4246834,17z/data=!3m1!4b1!4m5!3m4!1s0xd24fc6519e03b3d:0xb47f5e1a7515bd95!8m2!3d41.5414467!4d-8.4224894',
	            className: 'SchedulePage-room'
	          },
	          'Altice Forum Braga ',
	          _react2.default.createElement('br', null),
	          ' Main Room'
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-entry' },
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTime' },
	          '09:00'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTitle' },
	          'Check in'
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-entry' },
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTime' },
	          '09:50'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTitle' },
	          'Opening'
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-entry' },
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTime' },
	          '10:00'
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            href: '/speakers#vitaly-friedman',
	            className: 'SchedulePage-entryTitle'
	          },
	          'TBA',
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'SchedulePage-entrySpeaker' },
	            'by Vitaly Friedman'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-entry xl' },
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTime' },
	          '10:45'
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: '/speakers#jackie-balzer', className: 'SchedulePage-entryTitle' },
	          'Preprocessors, Components, and CSS in JS or: How I Learned to Stop Worrying and Love the Website',
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'SchedulePage-entrySpeaker' },
	            'by Jackie Balzer'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-entry' },
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTime' },
	          '11:30'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTitle' },
	          'Coffe Break ',
	          Xing
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-entry' },
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTime' },
	          '12:00'
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: '/speakers#lea-verou', className: 'SchedulePage-entryTitle' },
	          'Even More CSS Secrets',
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'SchedulePage-entrySpeaker' },
	            'by Lea Verou'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-entry' },
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTime' },
	          '13:00'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTitle' },
	          'Lunch'
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-entry' },
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTime' },
	          '15:00'
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: '/speakers#amber-case', className: 'SchedulePage-entryTitle' },
	          'Designing Calm Technology',
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'SchedulePage-entrySpeaker' },
	            'by Amber Case'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-entry' },
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTime' },
	          '15:45'
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: '/speakers#aras-bilgen', className: 'SchedulePage-entryTitle' },
	          'Avoiding Arctic Expeditions: Ways to do research together',
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'SchedulePage-entrySpeaker' },
	            'by Aras Bilgen'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-entry xl' },
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTime' },
	          '16:30'
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            href: '/speakers#jessica-jordan',
	            className: 'SchedulePage-entryTitle'
	          },
	          'Crafting Web Comics with Ember',
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'SchedulePage-entrySpeaker' },
	            'by Jessica Jordan'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-entry' },
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTime' },
	          '17:00'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTitle' },
	          'Coffe Break ',
	          Xing
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-entry' },
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTime' },
	          '17:30'
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: '/speakers#mike-monteiro', className: 'SchedulePage-entryTitle' },
	          'How To Build an Atomic Bomb',
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'SchedulePage-entrySpeaker' },
	            'by Mike Monteiro'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _AnimatedTable.Row,
	        { className: 'SchedulePage-entry' },
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTime' },
	          '18:30'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'SchedulePage-entryTitle' },
	          'Closing'
	        )
	      ),
	      _react2.default.createElement('div', { className: 'SchedulePage-fillers', style: { height: '70px' } }),
	      _react2.default.createElement('div', { className: 'SchedulePage-fillers', style: { height: '76px' } })
	    )
	  )
	);
	module.exports = exports['default'];

/***/ }),

/***/ 459:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactPose = __webpack_require__(289);
	
	var _reactPose2 = _interopRequireDefault(_reactPose);
	
	var _classnames = __webpack_require__(35);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(459);
	
	var _back = __webpack_require__(302);
	
	var _back2 = _interopRequireDefault(_back);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tab = _reactPose2.default.div({
	  active: {
	    delayChildren: 200,
	    staggerChildren: 50
	  },
	  inactive: {
	    delayChildren: 200,
	    staggerChildren: 50,
	    delay: 180,
	    beforeChildren: false
	  }
	});
	
	var Image = _reactPose2.default.img({
	  active: {
	    opacity: 1
	  },
	  inactive: {
	    opacity: 0
	  }
	});
	
	var Tabss = function (_Component) {
	  _inherits(Tabss, _Component);
	
	  function Tabss() {
	    _classCallCheck(this, Tabss);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.switchToTab = function (nextTabIndex) {
	      return function () {
	        return _this.setState({ activeTabIndex: nextTabIndex });
	      };
	    };
	
	    _this.isActive = function (index) {
	      return _this.state.activeTabIndex === index;
	    };
	
	    _this.renderNavigation = function () {
	      return _react.Children.map(_this.props.children, function (child, index) {
	        var active = _this.isActive(index);
	        var pose = active ? 'active' : 'inactive';
	        var className = (0, _classnames2.default)({
	          'Tabs-button': true,
	          'is-active': active,
	          flip: index === 0
	        });
	
	        return _react2.default.createElement(
	          'button',
	          { className: className, onClick: _this.switchToTab(index) },
	          child.props.title,
	          _react2.default.createElement(Image, { pose: pose, className: 'Tabs-activeTabIndicator', src: _back2.default })
	        );
	      });
	    };
	
	    _this.renderTabs = function () {
	      return _react.Children.map(_this.props.children, function (child, index) {
	        var active = _this.isActive(index);
	        var pose = active ? 'active' : 'inactive';
	        var className = (0, _classnames2.default)({
	          'Tabs-tab': true,
	          'is-active': active
	        });
	
	        return _react2.default.createElement(
	          Tab,
	          { className: className, pose: pose },
	          child
	        );
	      });
	    };
	
	    _this.state = { activeTabIndex: 0 };
	    return _this;
	  }
	
	  Tabss.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'Tabs' },
	      _react2.default.createElement(
	        'div',
	        { className: 'Tabs-navigation' },
	        this.renderNavigation()
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'Tabs-content' },
	        this.renderTabs()
	      )
	    );
	  };
	
	  return Tabss;
	}(_react.Component);
	
	exports.default = Tabss;
	module.exports = exports['default'];

/***/ }),

/***/ 302:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 460:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(460);
	
	var _Tabs = __webpack_require__(338);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _FirstPart = __webpack_require__(336);
	
	var _FirstPart2 = _interopRequireDefault(_FirstPart);
	
	var _SecondPart = __webpack_require__(337);
	
	var _SecondPart2 = _interopRequireDefault(_SecondPart);
	
	var _back = __webpack_require__(302);
	
	var _back2 = _interopRequireDefault(_back);
	
	var _next = __webpack_require__(705);
	
	var _next2 = _interopRequireDefault(_next);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SchedulePage = function (_Component) {
	  _inherits(SchedulePage, _Component);
	
	  function SchedulePage() {
	    _classCallCheck(this, SchedulePage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SchedulePage.prototype.render = function render() {
	    return _react2.default.createElement(
	      'section',
	      { className: 'SchedulePage' },
	      _react2.default.createElement(
	        'div',
	        { className: 'SchedulePage-wrapper' },
	        _react2.default.createElement(
	          'a',
	          { className: 'SchedulePage-backLink', href: '/#schedule' },
	          _react2.default.createElement('img', { className: 'SchedulePage-backImage', src: _back2.default }),
	          'Go back'
	        ),
	        _react2.default.createElement(
	          'h1',
	          { className: 'SchedulePage-heading' },
	          'The Mirror Times'
	        ),
	        _react2.default.createElement(
	          _Tabs2.default,
	          null,
	          _FirstPart2.default,
	          _SecondPart2.default
	        )
	      )
	    );
	  };
	
	  return SchedulePage;
	}(_react.Component);
	
	exports.default = SchedulePage;
	module.exports = exports['default'];

/***/ }),

/***/ 705:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SchedulePage = __webpack_require__(339);
	
	var _SchedulePage2 = _interopRequireDefault(_SchedulePage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Schedule = function (_Component) {
	  _inherits(Schedule, _Component);
	
	  function Schedule() {
	    _classCallCheck(this, Schedule);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Schedule.prototype.render = function render() {
	    return _react2.default.createElement(_SchedulePage2.default, null);
	  };
	
	  return Schedule;
	}(_react.Component);
	
	exports.default = Schedule;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-schedule-jsx.bundle.js